<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :customClass="'customer-create create-form'"
    v-if="getPermission('customer:create')"
  >
    <template v-slot:header-title>
      <h1 class="form-title d-flex">
        <template v-if="equipmentId > 0">
          Update {{ get_title_assets(companyEquipmentType) }}
        </template>
        <template v-else
          >Create {{ get_title_assets(companyEquipmentType) }}</template
        >
        <span class="ml-3 orange--text">
          <template v-if="formLoading">
            <v-skeleton-loader
              class="custom-skeleton height-20px custom-skeleton-full-width"
              width="100"
              type="text"
            >
            </v-skeleton-loader>
          </template>
          <template v-else> #{{ unique_barcode }} </template>
        </span>
      </h1>
    </template>
    <template v-slot:header-action>
      <div class="">
        <v-btn
          depressed
          v-if="!isCustomer"
          v-on:click="goBack"
          :disabled="formLoading"
          class="mx-2 custom-grey-border custom-bold-button"
        >
          Cancel
        </v-btn>

        <v-btn
          depressed
          :disabled="!formValid || formLoading"
          :loading="formLoading"
          class="mx-2 custom-bold-button white--text"
          v-on:click="updateOrCreate"
          color="cyan"
        >
          {{ equipmentId > 0 ? "Update" : "Save" }}
        </v-btn>
      </div>
    </template>
    <template v-slot:body>
      <v-form
        ref="assetForm"
        v-model.trim="formValid"
        lazy-validation
        v-on:submit.stop.prevent="updateOrCreate"
      >
        <v-tabs
          v-model="assetTab"
          background-color="transparent"
          centered
          color="cyan"
          fixed-tabs
          grow
          class="custom-tab-transparent"
          hide-slider
        >
          <template v-for="(tab, index) in tabs">
            <v-tab
              class="font-size-16 font-weight-600 px-8"
              v-if="getPermission(tab.permission + ':create') && tab.status"
              :key="index"
              :href="'#tab-' + tab.key"
            >
              <v-icon color="grey darken-4" left>{{ tab.icon }}</v-icon>
              {{ tab.title }}
            </v-tab>
          </template>
        </v-tabs>
        <v-row>
          <v-col cols="12" :md="3" :sm="3" class="text-center">
            <template>
              <v-img
                :lazy-src="$defaultImage"
                :src="getProfileImage ? getProfileImage : $defaultImage"
                max-height="200"
                max-width="200"
                height="200px"
                width="200px"
                class="custom-grey-border custom-border-radius-50 company-image-logo margin-auto"
              >
              </v-img>
              <div class="margin-auto">
                <v-btn
                  class="my-4 custom-bold-button"
                  outlined
                  small
                  v-on:click="selectImage"
                  color="cyan"
                  :loading="imageLoading"
                  :disabled="imageLoading"
                >
                  <template v-if="getProfileImage">Change Image</template>
                  <template v-else>Upload Image</template>
                </v-btn>

                <div class="d-none">
                  <v-file-input
                    ref="uploadImage"
                    v-on:change="updateProfileImage"
                    :rules="imageRules"
                    accept="image/png, image/jpeg, image/jpg"
                  ></v-file-input>
                </div>
              </div>
            </template>
          </v-col>
          <v-col cols="12" :md="7" :sm="7" class="py-0">
            <v-tabs-items v-model="assetTab" class="mb-12">
              <v-tab-item :value="'tab-overview'">
                <v-row>
                  <v-col
                    class="custom-content-container py-0"
                    cols="12"
                    :md="12"
                    :sm="12"
                  >
                    <div class="d-block customer-create-new-customer">
                      <v-row class="mx-0">
                        <v-col
                          class="iv-custom-field py-0 px-0"
                          cols="12"
                          md="12"
                          sm="12"
                        >
                          <perfect-scrollbar
                            :options="{ suppressScrollX: true }"
                            class="scroll"
                            style="max-height: 75vh; position: relative"
                          >
                            <v-container fluid>
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    <!-- Core Information -->
                                    {{ get_title_assets(companyEquipmentType) }}
                                    of
                                    {{ appCompanyName }}
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <template
                                    v-if="asset.main_type == 'main_customer'"
                                  >
                                    <v-row>
                                      <v-col v-if="!isCustomer">
                                        <label
                                          for="customer-equipment"
                                          class="font-weight-700 font-size-16 required"
                                          >Customer</label
                                        >
                                        <v-autocomplete
                                          hide-details
                                          :readonly="
                                            equipmentId > 0 ? true : false
                                          "
                                          id="customer-equipment"
                                          :items="customerList"
                                          dense
                                          flat
                                          filled
                                          placeholder="Customer"
                                          :rules="[
                                            validateRules.required(
                                              asset.customer,
                                              'customer'
                                            ),
                                          ]"
                                          item-color="cyan"
                                          color="cyan"
                                          solo
                                          v-model.trim="asset.customer"
                                          item-text="display_name"
                                          item-value="id"
                                          v-on:change="filter_property($event)"
                                        >
                                          <template v-slot:no-data>
                                            <v-list-item>
                                              <v-list-item-title
                                                v-html="'No Customer(s) Found.'"
                                              ></v-list-item-title>
                                            </v-list-item>
                                          </template>
                                          <template v-slot:item="{ item }">
                                            <v-list-item-avatar>
                                              <v-img
                                                :lazy-src="$defaultProfileImage"
                                                :src="
                                                  $assetAPIURL(
                                                    item.profile_logo
                                                  )
                                                "
                                                aspect-ratio="1"
                                                class="margin-auto"
                                                transition="fade-transition"
                                              ></v-img>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                              <v-list-item-title
                                                class="text-capitalize font-weight-500 font-size-16"
                                                >{{
                                                  item.display_name
                                                }}</v-list-item-title
                                              >
                                              <v-list-item-title
                                                class="text-capitalize font-weight-500 font-size-16"
                                                >{{
                                                  item.company_name
                                                }}</v-list-item-title
                                              >
                                            </v-list-item-content>
                                            <v-list-item-action
                                              v-if="item.default_person"
                                              class="align-self-center"
                                            >
                                              <v-list-item-subtitle
                                                class="text-lowercase pb-2 font-weight-500 font-size-14"
                                                >{{
                                                  item.default_person
                                                    .primary_email
                                                }}</v-list-item-subtitle
                                              >
                                              <v-list-item-subtitle
                                                class="text-lowercase font-weight-500 font-size-14"
                                                >{{
                                                  item.default_person
                                                    .primary_phone
                                                }}</v-list-item-subtitle
                                              >
                                            </v-list-item-action>
                                          </template>
                                        </v-autocomplete>
                                      </v-col>

                                      <v-col :lg="isCustomer ? 12 : 6">
                                        <label
                                          for="property-equipment"
                                          class="font-weight-700 font-size-16 required"
                                          >Site Location</label
                                        >
                                        <v-autocomplete
                                          hide-details
                                          id="property-equipment"
                                          :readonly="
                                            equipmentId > 0 ? true : false
                                          "
                                          :items="filtered_property"
                                          :rules="[
                                            validateRules.required(
                                              asset.property,
                                              'property'
                                            ),
                                          ]"
                                          v-model.trim="asset.property"
                                          dense
                                          flat
                                          filled
                                          placeholder="Site Location"
                                          item-color="cyan"
                                          color="cyan"
                                          solo
                                          item-text="barcode"
                                          item-value="id"
                                        >
                                          <template v-slot:no-data>
                                            <v-list-item>
                                              <v-list-item-title
                                                v-html="
                                                  'No Site Location(s) Found.'
                                                "
                                              ></v-list-item-title>
                                            </v-list-item>
                                          </template>
                                          <template v-slot:item="{ item }">
                                            <v-list-item-icon class="mr-3">
                                              <v-icon large
                                                >mdi-home-map-marker</v-icon
                                              >
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                              <v-layout
                                                style="max-width: 150px"
                                              >
                                                <v-flex>
                                                  <Barcode
                                                    class="my-0 mt-0 mb-0 mr-1"
                                                    :barcode="item.barcode"
                                                  >
                                                  </Barcode>
                                                </v-flex>
                                                <v-flex v-if="item.is_tenant">
                                                  <v-chip
                                                    class="mx-1"
                                                    label
                                                    small
                                                    color="green"
                                                    outlined
                                                    >Tenant</v-chip
                                                  >
                                                </v-flex>
                                                <v-flex>
                                                  <v-chip
                                                    label
                                                    small
                                                    class="ml-1"
                                                    :color="
                                                      item.type == 1
                                                        ? 'cyan'
                                                        : 'orange'
                                                    "
                                                    outlined
                                                  >
                                                    <template
                                                      v-if="item.type == 1"
                                                      >Site Location</template
                                                    >
                                                    <template v-else
                                                      >Billing</template
                                                    >
                                                  </v-chip>
                                                </v-flex>
                                              </v-layout>
                                              <v-list-item-title
                                                class="text-capitalize font-weight-500 font-size-16"
                                                >{{
                                                  get_formatted_property(item)
                                                }}
                                              </v-list-item-title>
                                            </v-list-item-content>
                                          </template>
                                        </v-autocomplete>
                                      </v-col>
                                    </v-row>

                                    <v-row>
                                      <v-col
                                        lg="12"
                                        v-if="asset.asset_type == 'company'"
                                      >
                                        <label
                                          for="customer-equipment"
                                          class="font-weight-700 font-size-16 required"
                                          >Product</label
                                        >
                                        <v-autocomplete
                                          hide-details
                                          id="customer-equipment"
                                          :items="products"
                                          v-model.trim="asset.product"
                                          dense
                                          flat
                                          filled
                                          placeholder="Product"
                                          item-color="cyan"
                                          color="cyan"
                                          solo
                                          item-text="barcode"
                                          :rules="[
                                            validateRules.required(
                                              asset.product,
                                              'product'
                                            ),
                                          ]"
                                          v-on:change="productData($event)"
                                          item-value="id"
                                        >
                                          <template v-slot:no-data>
                                            <v-list-item>
                                              <v-list-item-title
                                                v-html="'No Product(s) Found.'"
                                              ></v-list-item-title>
                                            </v-list-item>
                                          </template>
                                          <template v-slot:item="{ item }">
                                            <v-list-item-avatar>
                                              <v-img
                                                :lazy-src="$defaultImage"
                                                :src="
                                                  item &&
                                                  item.product_image &&
                                                  item.product_image.file &&
                                                  item.product_image.file.url
                                                "
                                                aspect-ratio="1"
                                                class="margin-auto"
                                                transition="fade-transition"
                                              ></v-img>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                              <v-list-item-title
                                                class="text-capitalize font-weight-500 font-size-16"
                                                >{{
                                                  item.name
                                                }}</v-list-item-title
                                              >
                                              <v-list-item-title
                                                class="text-capitalize font-weight-500 font-size-16"
                                                >{{
                                                  item.barcode
                                                }}</v-list-item-title
                                              >
                                            </v-list-item-content>
                                          </template>
                                        </v-autocomplete>
                                      </v-col>

                                      <v-col md="12" v-if="asset.product">
                                        <v-layout class="nmt-1 bg-quo">
                                          <v-flex
                                            md6
                                            class="mr-2 custom-border-right"
                                          >
                                            <table width="100%">
                                              <tr>
                                                <td class="p-0">
                                                  <v-img
                                                    v-if="
                                                      filteredProduct.product_image
                                                    "
                                                    :lazy-src="$defaultImage"
                                                    :src="
                                                      filteredProduct &&
                                                      filteredProduct.product_image &&
                                                      filteredProduct
                                                        .product_image.file &&
                                                      filteredProduct
                                                        .product_image.file.url
                                                    "
                                                    aspect-ratio="1"
                                                    transition="fade-transition"
                                                    max-height="60"
                                                    max-width="60"
                                                    height="60px"
                                                    width="60px"
                                                    class="custom-grey-border custom-border-radius-50 company-image-logo"
                                                  ></v-img>
                                                  <v-img
                                                    v-else
                                                    :lazy-src="$defaultImage"
                                                    :src="$defaultImage"
                                                    aspect-ratio="1"
                                                    transition="fade-transition"
                                                    max-height="60"
                                                    max-width="60"
                                                    height="60px"
                                                    width="60px"
                                                    class="custom-grey-border custom-border-radius-50 company-image-logo"
                                                  ></v-img>
                                                </td>
                                              </tr>
                                              <tr
                                                v-if="
                                                  filteredProduct &&
                                                  filteredProduct.serial_number
                                                "
                                              >
                                                <td
                                                  class="font-weight-600 pt-1 pb-0"
                                                >
                                                  <label>Item no:</label>
                                                </td>
                                                <td class="pt-1 pb-0">
                                                  <span
                                                    class="mr-2"
                                                    v-if="
                                                      filteredProduct &&
                                                      filteredProduct.serial_number
                                                    "
                                                  >
                                                    <v-chip
                                                      label
                                                      small
                                                      class="white--text"
                                                      color="blue
                                                    "
                                                      outlined
                                                      >{{
                                                        filteredProduct.serial_number
                                                      }}
                                                    </v-chip>
                                                  </span>
                                                </td>
                                              </tr>

                                              <tr
                                                v-if="
                                                  filteredProduct &&
                                                  filteredProduct.name
                                                "
                                              >
                                                <td
                                                  class="font-weight-600 pt-0 pb-0"
                                                >
                                                  <label>Name:</label>
                                                </td>
                                                <td class="pt-0 pb-0">
                                                  <span
                                                    class="mr-2"
                                                    v-if="
                                                      filteredProduct &&
                                                      filteredProduct.name
                                                    "
                                                  >
                                                    <label>{{
                                                      filteredProduct.name
                                                    }}</label></span
                                                  >
                                                </td>
                                              </tr>
                                              <tr
                                                v-if="
                                                  filteredProduct &&
                                                  filteredProduct.category_name
                                                "
                                              >
                                                <td
                                                  class="font-weight-600 pt-0 pb-0"
                                                >
                                                  <label>Category:</label>
                                                </td>
                                                <td class="pt-0 pb-0">
                                                  <span
                                                    class="mr-2"
                                                    v-if="
                                                      filteredProduct &&
                                                      filteredProduct.category_name
                                                    "
                                                  >
                                                    <label
                                                      v-if="
                                                        filteredProduct &&
                                                        filteredProduct.category_name
                                                      "
                                                      >{{
                                                        filteredProduct &&
                                                        filteredProduct.category_name
                                                      }}</label
                                                    >
                                                  </span>
                                                  <em v-else class="text-muted">
                                                    no category</em
                                                  >
                                                </td>
                                              </tr>
                                              <tr
                                                v-if="
                                                  filteredProduct &&
                                                  filteredProduct.brand
                                                "
                                              >
                                                <td
                                                  class="font-weight-600 pt-0 pb-0"
                                                >
                                                  <label>Brand:</label>
                                                </td>
                                                <td class="pt-0 pb-0">
                                                  <span
                                                    class="mr-2"
                                                    v-if="
                                                      filteredProduct &&
                                                      filteredProduct.brand
                                                    "
                                                  >
                                                    <label
                                                      v-if="
                                                        filteredProduct &&
                                                        filteredProduct.brand
                                                      "
                                                      >{{
                                                        filteredProduct &&
                                                        filteredProduct.brand
                                                      }}</label
                                                    >
                                                  </span>
                                                  <em v-else class="text-muted">
                                                    no brand</em
                                                  >
                                                </td>
                                              </tr>
                                              <tr
                                                v-if="
                                                  filteredProduct &&
                                                  filteredProduct.model
                                                "
                                              >
                                                <td
                                                  class="font-weight-600 pt-0 pb-0"
                                                >
                                                  <label>Model No:</label>
                                                </td>
                                                <td class="pt-0 pb-0">
                                                  <span
                                                    class="mr-2"
                                                    v-if="
                                                      filteredProduct &&
                                                      filteredProduct.model
                                                    "
                                                  >
                                                    <label
                                                      v-if="
                                                        filteredProduct &&
                                                        filteredProduct.model
                                                      "
                                                      >{{
                                                        filteredProduct &&
                                                        filteredProduct.model
                                                      }}</label
                                                    >
                                                  </span>
                                                  <em v-else class="text-muted">
                                                    no model</em
                                                  >
                                                </td>
                                              </tr>
                                              <tr
                                                v-if="
                                                  filteredProduct &&
                                                  filteredProduct.model_no
                                                "
                                              >
                                                <td
                                                  class="font-weight-600 pt-0 pb-0"
                                                >
                                                  <label>Model no.:</label>
                                                </td>
                                                <td class="pt-0 pb-0">
                                                  <span
                                                    class="mr-2"
                                                    v-if="
                                                      filteredProduct &&
                                                      filteredProduct.model_no
                                                    "
                                                  >
                                                    <label
                                                      v-if="
                                                        filteredProduct &&
                                                        filteredProduct.model_no
                                                      "
                                                      >{{
                                                        filteredProduct &&
                                                        filteredProduct.model_no
                                                      }}</label
                                                    >
                                                  </span>
                                                  <em v-else class="text-muted">
                                                    no model no</em
                                                  >
                                                </td>
                                              </tr>
                                            </table>
                                          </v-flex>
                                          <v-flex md6 class="mr-2">
                                            <table width="100%">
                                              <tr>
                                                <td class="font-weight-600">
                                                  <label>Description</label>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td
                                                  class="font-weight-600 pl-2"
                                                  v-if="
                                                    filteredProduct &&
                                                    filteredProduct.description
                                                  "
                                                >
                                                  {{
                                                    filteredProduct.description
                                                  }}
                                                </td>
                                                <em v-else class="text-muted">
                                                  no description</em
                                                >
                                              </tr>
                                            </table>
                                          </v-flex>
                                        </v-layout>
                                      </v-col>
                                    </v-row>
                                  </template>

                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 required font-size-16 width-100"
                                        >Name</label
                                      >
                                      <!-- <v-text-field
                                          id="name"
                                          v-model.trim="asset.name"
                                          :rules="[
                                            validateRules.required(
                                              asset.name,
                                              'name'
                                            ),
                                            validateRules.maxLength(40, 'name'),
                                          ]"
                                          dense
                                          filled
                                          placeholder="Name"
                                          solo
                                          flat
                                          color="cyan"
                                          class="width-100"
                                          maxlength="40"
                                        ></v-text-field> -->
                                      <TextField
                                        id="name"
                                        dense
                                        filled
                                        placeholder="Name"
                                        solo
                                        flat
                                        counter="50"
                                        v-model="asset.name"
                                        color="cyan"
                                        :maxlength="250"
                                        :rules="[
                                          validateRules.required(
                                            asset.name,
                                            'Name'
                                          ),
                                        ]"
                                      />
                                      <!-- <div class="text-end">{{asset?.name?.length}}/40</div> -->
                                      <!--required-field-->
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 required font-size-16 width-100"
                                        >Serial No.</label
                                      >
                                      <v-text-field
                                        id="Serial No."
                                        v-model.trim="asset.serial_no"
                                        @keypress="
                                          ($event) =>
                                            blockSpecialCharacters($event)
                                        "
                                        @paste="($event) => handlePaste($event)"
                                        :rules="[
                                          validateRules.required(
                                            asset.serial_no,
                                            'Serial No.'
                                          ),
                                        ]"
                                        dense
                                        filled
                                        placeholder="Serial No."
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                      <!--required-field-->
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6">
                                      <div class="d-flex justify-space-between">
                                        <label
                                          class="pr-2 font-weight-700 font-size-16 width-100"
                                          >Brand
                                        </label>
                                        <v-icon
                                          @click="manage_brand = true"
                                          small
                                          >mdi-cog</v-icon
                                        >
                                      </div>
                                      <v-autocomplete
                                        hide-details
                                        id="brand-equipment"
                                        :items="brands"
                                        dense
                                        flat
                                        filled
                                        placeholder="Brand"
                                        item-color="cyan"
                                        v-model="asset.brand"
                                        color="cyan"
                                        solo
                                        item-text="text"
                                        item-value="text"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-title
                                              v-html="'No Brand(s) Found.'"
                                            ></v-list-item-title>
                                          </v-list-item>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                    <v-col lg="6">
                                      <div class="d-flex justify-space-between">
                                        <label
                                          class="pr-2 font-weight-700 font-size-16 width-100"
                                          >Category
                                        </label>
                                        <v-icon
                                          @click="manageGroupDialog = true"
                                          small
                                          >mdi-cog</v-icon
                                        >
                                      </div>
                                      <v-autocomplete
                                        dense
                                        filled
                                        color="cyan"
                                        item-color="cyan"
                                        :items="categoryList"
                                        placeholder="Category"
                                        solo
                                        flat
                                        item-text="text"
                                        item-value="text"
                                        class="width-100"
                                        v-model.trim="asset.category"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-content>
                                              <v-list-item-title
                                                v-html="'No Category(s) Found.'"
                                              ></v-list-item-title>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="false">
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Contact for Item</label
                                      >

                                      <PhoneTextField
                                        v-model="asset.company_number"
                                      ></PhoneTextField>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Model No.</label
                                      >
                                      <v-text-field
                                        id="model-equipment"
                                        dense
                                        filled
                                        placeholder="Model"
                                        solo
                                        v-model="asset.model"
                                        flat
                                        color="cyan"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Specification</label
                                      >
                                      <v-text-field
                                        id="specification"
                                        v-model.trim="asset.specification"
                                        dense
                                        filled
                                        placeholder="Specification"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Tags</label
                                      >
                                      <TagAutoComplete
                                        type="asset"
                                        v-model="asset.tags"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100 required"
                                        >Machine No.</label
                                      >
                                      <v-text-field
                                        id="machine-no."
                                        v-model.trim="asset.machine_number"
                                        dense
                                        filled
                                        placeholder="Machine No."
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                        :rules="[
                                          validateRules.required(
                                            asset.machine_number,
                                            'Machine No.'
                                          ),
                                        ]"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-row>
                                    <v-col lg="12">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >{{
                                          get_title_assets(companyEquipmentType)
                                        }}
                                        Description</label
                                      >
                                      <TextAreaField
                                        auto-grow
                                        dense
                                        filled
                                        color="cyan"
                                        v-model.trim="asset.description"
                                        placeholder="Description"
                                        solo
                                        flat
                                        row-height="25"
                                        counter="200"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <!--  <v-col lg="3" class="d-flex">
                                        <label>Is Return After End Life ? </label>
                                        <v-switch
                                          class="ml-4"
                                          color="cyan"
                                          dense
                                          inset
                                          hide-details
                                          v-model="asset.is_return"
                                        ></v-switch>
                                      </v-col> -->

                                    <v-col lg="12" class="d-flex" v-if="false">
                                      <label
                                        >Is there any Preventive Maintenance ?
                                      </label>
                                      <v-switch
                                        class="ml-4"
                                        color="cyan"
                                        dense
                                        :readonly="
                                          equipmentId > 0 ? true : false
                                        "
                                        inset
                                        hide-details
                                        v-on:change="changeMaintananceCheck"
                                        v-model="asset.check_maintanance"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>

                              <!-- Events & Site Information-->
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    Skills , Licence & Certs Information
                                  </h3>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    class="white--text mr-2"
                                    depressed
                                    color="cyan"
                                    tile
                                    @click="addCert_dialog = true"
                                  >
                                    <v-icon left>mdi-plus</v-icon>
                                    Add
                                  </v-btn>
                                </v-card-title>
                                <v-card-text
                                  style="padding-left: 14px !important"
                                >
                                  <div
                                    class="pl-2"
                                    style="background: whitesmoke"
                                  >
                                    <v-row>
                                      <v-col cols="2" lg="2" class="py-0 pl-1">
                                        <label
                                          class="font-weight-700 font-size-16 width-100 mt-1"
                                          >Color</label
                                        >
                                      </v-col>
                                      <v-col cols="4" lg="4" class="py-0 pl-1">
                                        <label
                                          class="font-weight-700 font-size-16 width-100 mt-1"
                                          >Name</label
                                        >
                                      </v-col>
                                      <v-col cols="4" lg="4" class="py-0 pl-0">
                                        <label
                                          class="font-weight-700 font-size-16 width-100 mt-1"
                                          >Type</label
                                        >
                                      </v-col>
                                    </v-row>
                                  </div>
                                  <template>
                                    <div v-if="asset?.skills_carts?.length > 0">
                                      <v-row
                                        v-for="(
                                          row, index
                                        ) in asset.skills_carts"
                                        :key="index"
                                        class="mb-0 mx-1"
                                        style="border-bottom: 1px solid #ddd7d7"
                                      >
                                        <v-col
                                          cols="2"
                                          lg="2"
                                          class="py-0 my-auto"
                                        >
                                          <v-chip
                                            small
                                            :color="row.color"
                                            variant="flat"
                                          ></v-chip>
                                        </v-col>
                                        <v-col
                                          cols="4"
                                          lg="4"
                                          class="py-0 pl-1 my-auto"
                                        >
                                          {{ row.name }}
                                        </v-col>
                                        <v-col
                                          cols="4"
                                          lg="4"
                                          class="py-0 pl-1 my-auto"
                                        >
                                          {{ row.type }}
                                        </v-col>
                                        <v-col
                                          cols="2"
                                          lg="2"
                                          class="py-0 my-auto"
                                        >
                                          <v-btn
                                            icon
                                            class="white--text"
                                            depressed
                                            color="red darken-4"
                                            @click="removeCert(index)"
                                            min-width="25"
                                            max-width="25"
                                            width="25"
                                          >
                                            <v-icon>mdi-delete</v-icon>
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </div>
                                    <div v-else>
                                      <p
                                        class="m-0 row-not-found text-center font-weight-500 font-size-16"
                                      >
                                        <img
                                          :src="
                                            $assetURL('media/error/empty.png')
                                          "
                                          class="row-not-found-image"
                                          style="width: 20px"
                                        />
                                        Uhh... There are no item at the moment.
                                      </p>
                                    </div>
                                  </template>
                                </v-card-text>
                              </v-card>
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius mt-3"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    Events & Site Information
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Installation Date</label
                                      >
                                      <DatePicker
                                        solo
                                        flat
                                        :mandatory="false"
                                        :nullable="true"
                                        placeholder="Installation Date"
                                        v-model="asset.installation_date"
                                        :min-date="minDate"
                                        color="cyan"
                                        :default-date="asset.installation_date"
                                        v-on:change="getDates()"
                                      ></DatePicker>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Commission Date</label
                                      >
                                      <DatePicker
                                        solo
                                        flat
                                        :mandatory="false"
                                        :nullable="true"
                                        placeholder="Commission Date"
                                        v-model="asset.activation_date"
                                        :min-date="minDate"
                                        :default-date="asset.activation_date"
                                      >
                                      </DatePicker>
                                    </v-col>
                                  </v-row>

                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >End Life</label
                                      >
                                      <DatePicker
                                        solo
                                        flat
                                        :mandatory="false"
                                        :nullable="true"
                                        placeholder="End Life"
                                        v-model="asset.end_life"
                                        :min-date="asset.installation_date"
                                        :default-date="asset.end_life"
                                        v-on:change="getDates()"
                                      >
                                      </DatePicker>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Useful life / lifespan</label
                                      >
                                      <div class="mt-2">
                                        <div class="mt-2 font-weight-700">
                                          <template v-if="getDates()">{{
                                            getDates()
                                          }}</template
                                          ><template v-else>-</template>
                                        </div>
                                      </div>
                                      <!-- <DatePicker
                                          solo
                                          flat
                                          :mandatory="false"
                                          :nullable="true"
                                          placeholder="End Life"
                                          v-model="asset.end_life"
                                          :min-date="minDate"
                                          :default-date="asset.end_life"
                                        >
                                        </DatePicker> -->
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="false">
                                    <v-col lg="6">
                                      <div class="d-flex justify-space-between">
                                        <label
                                          class="pr-2 font-weight-700 font-size-16 width-100"
                                          >Location
                                        </label>
                                      </div>
                                      <v-autocomplete
                                        hide-details
                                        id="property-equipment"
                                        :items="all_property"
                                        v-model.trim="asset.site_location"
                                        dense
                                        flat
                                        filled
                                        @change="
                                          getLocation(asset.site_location)
                                        "
                                        placeholder="Location"
                                        item-color="cyan"
                                        color="cyan"
                                        solo
                                        item-text="barcode"
                                        item-value="id"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-title
                                              v-html="
                                                'No Site Location(s) Found.'
                                              "
                                            ></v-list-item-title>
                                          </v-list-item>
                                        </template>
                                        <template v-slot:item="{ item }">
                                          <v-list-item-icon class="mr-3">
                                            <v-icon large
                                              >mdi-home-map-marker</v-icon
                                            >
                                          </v-list-item-icon>

                                          <v-list-item-content>
                                            <v-layout style="max-width: 150px">
                                              <v-flex>
                                                <Barcode
                                                  class="my-0 mt-0 mb-0 mr-1"
                                                  :barcode="item.barcode"
                                                ></Barcode>
                                              </v-flex>
                                              <v-flex v-if="item.is_tenant">
                                                <v-chip
                                                  class="mx-1"
                                                  label
                                                  small
                                                  color="green"
                                                  outlined
                                                  >Tenant</v-chip
                                                >
                                              </v-flex>
                                              <v-flex>
                                                <v-chip
                                                  label
                                                  small
                                                  class="ml-1"
                                                  :color="
                                                    item.type == 1
                                                      ? 'cyan'
                                                      : 'orange'
                                                  "
                                                  outlined
                                                >
                                                  <template
                                                    v-if="item.type == 1"
                                                    >Site Location</template
                                                  >
                                                  <template v-else
                                                    >Billing</template
                                                  >
                                                </v-chip>
                                              </v-flex>
                                            </v-layout>
                                            <v-list-item-title
                                              class="text-capitalize font-weight-500 font-size-16"
                                              >{{
                                                get_formatted_property(item)
                                              }}
                                            </v-list-item-title>
                                          </v-list-item-content>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Address
                                      </label>
                                      <div class="" v-if="show_location">
                                        {{
                                          get_formatted_property(show_location)
                                        }}
                                      </div>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6">
                                      <div class="d-flex justify-space-between">
                                        <label
                                          class="pr-2 font-weight-700 font-size-16 width-100"
                                          >Sub-Location
                                        </label>
                                        <!-- <v-icon
                                          @click="manage_location = true"
                                          small
                                          >mdi-cog</v-icon
                                        > -->
                                      </div>
                                      <v-autocomplete
                                        hide-details
                                        id="sub_location"
                                        :items="equipment_locations"
                                        dense
                                        v-model="asset.location"
                                        flat
                                        filled
                                        placeholder="Sub-Location"
                                        item-color="cyan"
                                        color="cyan"
                                        solo
                                        item-text="text"
                                        item-value="id"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-title
                                              v-html="
                                                'No Sub-Location(s) Found.'
                                              "
                                            ></v-list-item-title>
                                          </v-list-item>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                    <v-col lg="6"> </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <!-- Events & Site Information end-->

                              <!--Purchase Information-->
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius mt-3"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    {{ get_title_assets(companyEquipmentType) }}
                                    Purchase Information
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Sales Person</label
                                      >
                                      <v-text-field
                                        id="sales_person"
                                        v-model.trim="asset.salesperson"
                                        dense
                                        filled
                                        placeholder="Sales Person"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                      >
                                        Supplier</label
                                      >
                                      <v-autocomplete
                                        hide-details
                                        id="supplier"
                                        :items="supplierList"
                                        dense
                                        v-model="asset.vendor"
                                        flat
                                        filled
                                        placeholder="Supplier"
                                        item-color="cyan"
                                        color="cyan"
                                        solo
                                        item-text="display_name"
                                        item-value="id"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-title
                                              v-html="'No Supplier(s) Found.'"
                                            ></v-list-item-title>
                                          </v-list-item>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                      >
                                        Purchase Price</label
                                      >
                                      <v-text-field
                                        :min="0"
                                        oninput="if(this.value < 0) this.value = 0;"
                                        type="number"
                                        hide-details
                                        dense
                                        solo
                                        flat
                                        :disabled="formLoading"
                                        :loading="formLoading"
                                        placeholder="Purchase Price"
                                        hide-spin-buttons
                                        prepend-inner-icon="mdi-currency-usd"
                                        v-model="asset.purchase_price"
                                        v-on:keypress="
                                          limitDecimal(
                                            $event,
                                            asset.purchase_price
                                          )
                                        "
                                        class="mt-0"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                      >
                                        Purchase Date</label
                                      >
                                      <DatePicker
                                        solo
                                        flat
                                        :mandatory="false"
                                        :nullable="true"
                                        placeholder=" Purchase Date"
                                        v-model="asset.purchase_date"
                                        :default-date="asset.purchase_date"
                                      ></DatePicker>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Quotation No.</label
                                      >
                                      <v-text-field
                                        id="quotation_no"
                                        v-model.trim="asset.quotation_no"
                                        dense
                                        filled
                                        placeholder="Quotation No."
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                      >
                                        Invoice No.</label
                                      >
                                      <v-text-field
                                        id="invoice_no"
                                        v-model.trim="asset.invoice_no"
                                        dense
                                        filled
                                        placeholder="Invoice No."
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <!--Purchase Information end-->

                              <!--Delivery Info-->
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius mt-3"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    {{ get_title_assets(companyEquipmentType) }}
                                    Delivery Info
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >DO No.</label
                                      >
                                      <v-text-field
                                        id="do_no"
                                        v-model.trim="asset.do_no"
                                        dense
                                        filled
                                        placeholder="DO No."
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Commission Cert No.</label
                                      >
                                      <v-text-field
                                        id="common_cert_no"
                                        v-model.trim="asset.common_cert_no"
                                        dense
                                        filled
                                        placeholder="Commission Cert No."
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6" v-if="false">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Sales Employee</label
                                      >
                                      <v-text-field
                                        id="sales_employee"
                                        v-model.trim="asset.sales_employee"
                                        dense
                                        filled
                                        placeholder="Sales Employee"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Arrival Date</label
                                      >
                                      <DatePicker
                                        solo
                                        flat
                                        :mandatory="false"
                                        :nullable="true"
                                        placeholder="Arrival Date"
                                        v-model="asset.arrival_date"
                                        :default-date="asset.arrival_date"
                                      ></DatePicker>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Delivery Date</label
                                      >
                                      <DatePicker
                                        solo
                                        flat
                                        :mandatory="false"
                                        :nullable="true"
                                        placeholder="Delivery Date"
                                        v-model="asset.delivery_date"
                                        :default-date="asset.delivery_date"
                                      ></DatePicker>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="12">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Delivery Remark</label
                                      >
                                      <TextAreaField
                                        auto-grow
                                        dense
                                        filled
                                        color="cyan"
                                        v-model.trim="asset.delivery_remark"
                                        placeholder="Delivery Remark"
                                        solo
                                        flat
                                        row-height="25"
                                        counter="200"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <!--Delivery Info end-->

                              <!-- Is any Warranty  -->
                              <v-row>
                                <v-col lg="12" class="d-flex">
                                  <label>Is there any warranty ? </label>
                                  <v-switch
                                    class="ml-4"
                                    color="cyan"
                                    dense
                                    :readonly="equipmentId > 0 ? true : false"
                                    inset
                                    hide-details
                                    v-on:change="changeWarrantyCheck"
                                    v-model="asset.check_warranty"
                                  ></v-switch>
                                </v-col>
                              </v-row>

                              <v-card
                                v-if="
                                  asset.is_purchase_info &&
                                  asset.asset_type == 'company' &&
                                  false
                                "
                                flat
                                class="custom-grey-border remove-border-radius mt-4"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    Purchased Information
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >Cost Price</label
                                      >
                                      <v-text-field
                                        id="cost_price"
                                        v-model.trim="asset.cost_price"
                                        dense
                                        filled
                                        placeholder="Cost Price"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >Purchased On</label
                                      >
                                      <DatePicker
                                        solo
                                        flat
                                        :mandatory="false"
                                        :nullable="true"
                                        placeholder="Purchased On"
                                        v-model="asset.purchased_on"
                                        :default-date="asset.purchased_on"
                                      ></DatePicker>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="12">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >Supplier</label
                                      >
                                      <v-autocomplete
                                        :items="supplierList"
                                        dense
                                        filled
                                        color="cyan"
                                        item-color="cyan"
                                        placeholder="Supplier"
                                        solo
                                        flat
                                        item-text="display_name"
                                        item-value="id"
                                        class="pl-2 width-100"
                                        v-model.trim="asset.vendor"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-content>
                                              <v-list-item-title
                                                v-html="'No Supplier(s) Found.'"
                                              ></v-list-item-title>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                  </v-row>
                                  <!--  <v-row>
                                      <v-col lg="12">
                                        <label
                                          class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                          >Description</label
                                        >
                                        <v-textarea
                                          v-model.trim="asset.description"
                                          auto-grow
                                          dense
                                          filled
                                          color="cyan"
                                          placeholder="Asset Remark"
                                          solo
                                          flat
                                          row-height="15"
                                          v-on:paste="(e) => onPaste(e)"
                                          v-on:keypress="(e) => manageLimit(e)"
                                        ></v-textarea>
                                        <v-col md="12" class="text-right"
                                          >{{
                                            asset.description
                                              ? asset.description.length
                                              : 0
                                          }}/200</v-col
                                        >
                                      </v-col>
                                    </v-row> -->
                                </v-card-text>
                              </v-card>
                            </v-container>
                          </perfect-scrollbar>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :value="'tab-allocate-details'"> </v-tab-item>
              <v-tab-item
                :value="'tab-warranty'"
                v-if="assetTab == 'tab-warranty'"
              >
                <v-layout class="d-block customer-create-new-customer">
                  <v-row>
                    <v-col
                      class="iv-custom-field py-0 px-0"
                      cols="12"
                      md="12"
                      sm="12"
                    >
                      <perfect-scrollbar
                        :options="{ suppressScrollX: true }"
                        class="scroll"
                        style="max-height: 75vh; position: relative"
                      >
                        <v-container fluid>
                          <v-card
                            flat
                            class="custom-grey-border remove-border-radius"
                          >
                            <v-card-title class="headline grey lighten-4">
                              <h3
                                class="font-weight-700 custom-headline color-custom-blue"
                              >
                                Warranty Information
                              </h3>
                            </v-card-title>
                            <v-card-text class="p-6 font-size-16">
                              <v-row>
                                <v-col lg="6">
                                  <label
                                    class="pr-2 font-weight-700 font-size-16 width-100"
                                    for="asset_type"
                                    >Warranty Duration
                                  </label>
                                  <v-text-field
                                    type="number"
                                    id="duration"
                                    v-model.trim="asset.warranty_duration"
                                    dense
                                    filled
                                    placeholder="Duration"
                                    solo
                                    :disabled="equipmentId > 0 ? true : false"
                                    flat
                                    color="cyan"
                                    class="width-100"
                                    v-on:keyup="
                                      (e) =>
                                        updateWarrantyDuration(
                                          e,
                                          'warranty_duration'
                                        )
                                    "
                                    v-mask="'###'"
                                    :min="0"
                                    oninput="if(this.value < 0) this.value = 0;"
                                  ></v-text-field>
                                </v-col>
                                <v-col lg="6">
                                  <label
                                    class="pr-2 font-weight-700 font-size-16 width-100"
                                    for="asset_type"
                                    >Warranty Duration Type</label
                                  >
                                  <v-autocomplete
                                    :items="durationTypeList"
                                    dense
                                    :disabled="equipmentId > 0 ? true : false"
                                    filled
                                    color="cyan"
                                    item-color="cyan"
                                    placeholder="Duration Type"
                                    solo
                                    v-on:change="
                                      (e) =>
                                        updateWarrantyDuration(
                                          e,
                                          'warranty_duration_type'
                                        )
                                    "
                                    flat
                                    item-text="text"
                                    item-value="value"
                                    class="width-100"
                                    v-model.trim="asset.warranty_duration_type"
                                  >
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col lg="6">
                                  <label
                                    class="pr-2 font-weight-700 font-size-16 width-100 required"
                                    >Start Date
                                  </label>
                                  <DatePicker
                                    solo
                                    :disabled="dateDisable()"
                                    flat
                                    :rules="[
                                      validateRules.required(
                                        asset.warranty_start_date,
                                        'warranty_start_date'
                                      ),
                                    ]"
                                    :nullable="true"
                                    placeholder="Start Date"
                                    v-model="asset.warranty_start_date"
                                    :default-date="asset.warranty_start_date"
                                    v-on:change="
                                      (e) =>
                                        updateWarrantyDuration(
                                          e,
                                          'warranty_start_date'
                                        )
                                    "
                                    :offWeekend="false"
                                  ></DatePicker>
                                </v-col>
                                <v-col lg="6">
                                  <label
                                    class="pr-2 font-weight-700 font-size-16 width-100 required"
                                    >End Date</label
                                  >
                                  <div class="ml-1 black--text">
                                    {{ formatDate(asset.warranty_end_date) }}
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col lg="6">
                                  <label
                                    class="pr-2 font-weight-700 font-size-16 width-100"
                                    >Cost</label
                                  >
                                  <v-text-field
                                    type="number"
                                    id="cost"
                                    v-model.trim.number="asset.warranty_cost"
                                    dense
                                    filled
                                    placeholder="Cost"
                                    solo
                                    flat
                                    color="cyan"
                                    class="width-100"
                                    :disabled="equipmentId > 0 ? true : false"
                                    :min="0"
                                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57) || event.charCode==46)"
                                  ></v-text-field>
                                  <!--oninput="if(this.value < 0) this.value = 0;"-->
                                </v-col>
                                <v-col lg="6">
                                  <label
                                    class="pr-2 font-weight-700 font-size-16 width-100 required"
                                    >Reference No.</label
                                  >
                                  <v-text-field
                                    dense
                                    filled
                                    :disabled="equipmentId > 0 ? true : false"
                                    :rules="[
                                      validateRules.required(
                                        asset.warranty_reference,
                                        'Reference No.'
                                      ),
                                    ]"
                                    color="cyan"
                                    placeholder="Reference No."
                                    solo
                                    flat
                                    v-model.trim="asset.warranty_reference"
                                  ></v-text-field>
                                  <!--oninput="if(this.value < 0) this.value = 0;"-->
                                </v-col>
                                <v-col lg="12">
                                  <label
                                    class="pr-2 font-weight-700 font-size-16 width-100"
                                    >Warranty Description</label
                                  >
                                  <TextAreaField
                                    auto-grow
                                    dense
                                    filled
                                    color="cyan"
                                    :disabled="equipmentId > 0 ? true : false"
                                    v-model.trim="asset.warranty_remark"
                                    placeholder="Description"
                                    solo
                                    flat
                                    row-height="25"
                                    counter="200"
                                  />
                                  <!-- <v-textarea
                                          :disabled="
                                            equipmentId > 0 ? true : false
                                          "
                                          v-model.trim="asset.warranty_remark"
                                          auto-grow
                                          dense
                                          filled
                                          solo
                                          flat
                                          v-on:keypress="(e) => manageLimit(e)"
                                          v-on:paste="(e) => onPaste(e)"
                                          color="cyan"
                                          placeholder="Description"
                                          row-height="20"
                                        ></v-textarea>
                                        <div class="text-right">
                                          {{
                                            asset.warranty_remark
                                              ? asset.warranty_remark.length
                                              : 0
                                          }}/200
                                        </div> -->
                                  <!--oninput="if(this.value < 0) this.value = 0;"-->
                                </v-col>
                              </v-row>
                              <template
                                v-if="
                                  asset &&
                                  asset.warranty_reminder &&
                                  asset.warranty_reminder.length > 0 &&
                                  false
                                "
                              >
                                <template
                                  v-for="(
                                    data, index
                                  ) in asset.warranty_reminder"
                                >
                                  <v-row
                                    :key="`file-row-${index}`"
                                    :class="{
                                      'table-alternate-row': index % 2,
                                    }"
                                  >
                                    <v-col md="12" class="py-0">
                                      <label
                                        class="pr-2 pl-2 mt-3 font-weight-700 font-size-16 width-100"
                                        >Reminder</label
                                      >
                                    </v-col>
                                    <v-col md="10" class="py-0">
                                      <v-row>
                                        <v-col md="12" class="py-0">
                                          <v-layout>
                                            <v-flex md4>
                                              <v-radio-group
                                                hide-details
                                                id="export-type"
                                                class="pt-0"
                                                v-on:change="
                                                  manageReminder(
                                                    index,
                                                    'warranty'
                                                  )
                                                "
                                                v-model="data.type"
                                                row
                                              >
                                                <v-radio
                                                  label="After"
                                                  color="cyan"
                                                  value="after"
                                                ></v-radio>
                                                <v-radio
                                                  label="Before"
                                                  color="cyan"
                                                  value="before"
                                                ></v-radio>
                                              </v-radio-group>
                                            </v-flex>
                                            <v-flex md4>
                                              <v-text-field
                                                id="duration"
                                                v-model.trim="data.duration"
                                                dense
                                                filled
                                                placeholder="Duration"
                                                solo
                                                flat
                                                color="cyan"
                                                class="pr-2 width-100"
                                                v-on:keyup="
                                                  manageReminder(
                                                    index,
                                                    'warranty'
                                                  )
                                                "
                                              ></v-text-field>
                                            </v-flex>
                                            <v-flex md4>
                                              <v-autocomplete
                                                :items="durationTypeList"
                                                dense
                                                filled
                                                color="cyan"
                                                item-color="cyan"
                                                placeholder="Duration Type"
                                                solo
                                                flat
                                                item-text="text"
                                                item-value="text"
                                                class="pl-2 width-100"
                                                v-on:change="
                                                  manageReminder(
                                                    index,
                                                    'warranty'
                                                  )
                                                "
                                                v-model.trim="
                                                  data.duration_type
                                                "
                                              >
                                              </v-autocomplete>
                                            </v-flex>
                                          </v-layout>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col md="2" class="my-auto py-0">
                                      <v-row>
                                        <v-col md="6" class="py-0">
                                          <v-btn
                                            :disabled="
                                              asset?.warranty_reminder?.length <
                                              2
                                            "
                                            v-on:click="
                                              removeWarrantyReminder(index)
                                            "
                                            class="white--text"
                                            depressed
                                            color="red darken-4"
                                            tile
                                            style="margin-left: -10px"
                                          >
                                            <v-icon>mdi-delete</v-icon>
                                          </v-btn>
                                        </v-col>
                                        <v-col md="6" class="py-0">
                                          <v-btn
                                            :disabled="
                                              asset?.warranty_reminder?.length >
                                                4 || equipmentId > 0
                                            "
                                            v-on:click="
                                              addMoreWarrantyReminder()
                                            "
                                            class="white--text"
                                            depressed
                                            color="cyan"
                                            tile
                                            style="margin-left: -13px"
                                          >
                                            <v-icon>mdi-plus</v-icon>
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </template>
                              </template>
                              <div class="mt-5" v-if="false">
                                <FileUpload
                                  v-model="wtx_attachments"
                                ></FileUpload>
                              </div>
                              <template
                                v-if="
                                  false &&
                                  wtx_attachments &&
                                  wtx_attachments.length > 0
                                "
                              >
                                <template
                                  v-for="(file, indexFile) in wtx_attachments"
                                >
                                  <v-row
                                    :key="`warranty-file-row-${indexFile}`"
                                    :class="{
                                      'table-alternate-row': indexFile % 2,
                                    }"
                                  >
                                    <v-col md="12" class="py-0">
                                      <label
                                        class="pr-2 pl-2 mt-3 font-weight-700 font-size-16 width-100"
                                        >Attachment</label
                                      >
                                    </v-col>
                                    <v-col md="10" class="py-0">
                                      <v-row>
                                        <v-col md="12" class="py-0">
                                          <v-layout>
                                            <v-flex md6>
                                              <v-file-input
                                                :id="`document-file-${indexFile}`"
                                                placeholder="Select File"
                                                class="removeShadow"
                                                prepend-icon=""
                                                dense
                                                solo
                                                prepend-inner-icon="mdi-attachment"
                                                hide-details
                                                v-model="file.file"
                                                v-on:change="
                                                  updateFile(indexFile, $event)
                                                "
                                                v-on:click:clear="
                                                  updateFile(indexFile, $event)
                                                "
                                              ></v-file-input>
                                            </v-flex>
                                            <v-flex md6>
                                              <v-text-field
                                                :id="`document-name-${indexFile}`"
                                                v-model="file.name"
                                                dense
                                                filled
                                                placeholder="File Name"
                                                solo
                                                flat
                                                color="cyan"
                                                class="pr-2 width-100"
                                              ></v-text-field>
                                            </v-flex>
                                          </v-layout>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col md="2" class="my-auto py-0">
                                      <v-row>
                                        <v-col md="6" class="py-0">
                                          <v-btn
                                            :disabled="
                                              wtx_attachments?.length < 2
                                            "
                                            v-on:click="
                                              removeFileWarranty(indexFile)
                                            "
                                            class="white--text"
                                            depressed
                                            color="red darken-4"
                                            tile
                                            style="margin-left: -10px"
                                          >
                                            <v-icon>mdi-delete</v-icon>
                                          </v-btn>
                                        </v-col>
                                        <v-col md="6" class="py-0">
                                          <v-btn
                                            :disabled="
                                              wtx_attachments?.length > 4
                                            "
                                            v-on:click="addMoreWarranty()"
                                            class="white--text"
                                            depressed
                                            color="cyan"
                                            tile
                                            style="margin-left: -13px"
                                          >
                                            <v-icon>mdi-plus</v-icon>
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </template>
                              </template>
                              <!--  <v-row>
                                      <v-col lg="12">
                                        <label
                                          class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                          >Remarks</label
                                        >
                                        <v-textarea
                                          v-model.trim="asset.warranty_remarks"
                                          auto-grow
                                          dense
                                          filled
                                          color="cyan"
                                          placeholder="Asset Remark"
                                          solo
                                          flat
                                          row-height="15"
                                          v-on:paste="(e) => onPaste(e)"
                                          v-on:keypress="(e) => manageLimit(e)"
                                        ></v-textarea>
                                        <v-col md="12" class="text-right"
                                          >{{
                                            asset.description
                                              ? asset.description.length
                                              : 0
                                          }}/200</v-col
                                        >
                                      </v-col>
                                    </v-row> -->
                            </v-card-text>
                          </v-card>
                        </v-container>
                      </perfect-scrollbar>
                    </v-col>
                  </v-row>
                </v-layout>
              </v-tab-item>

              <v-tab-item
                :value="'tab-preventive-maintanance'"
                v-if="assetTab == 'tab-preventive-maintanance'"
              >
                <v-layout>
                  <v-col
                    class="custom-content-container pt-0"
                    cols="12"
                    :md="12"
                    :sm="12"
                  >
                    <v-layout class="d-block customer-create-new-customer">
                      <v-row>
                        <v-col class="iv-custom-field" cols="12" md="9" sm="9">
                          <perfect-scrollbar
                            :options="{ suppressScrollX: true }"
                            class="scroll"
                            style="max-height: 90vh; position: relative"
                          >
                            <v-container fluid>
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    Maintenance Information
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >Duration</label
                                      >
                                      <v-text-field
                                        filled
                                        placeholder="Duration"
                                        solo
                                        flat
                                        color="cyan"
                                        dense
                                        v-model.trim="asset.preventive_duration"
                                        v-mask="'###'"
                                        v-on:keyup="
                                          (e) =>
                                            updatePreventiveDuration(
                                              e,
                                              'warranty_duration'
                                            )
                                        "
                                        :disabled="
                                          equipmentId > 0 ? true : false
                                        "
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >Duration Type</label
                                      >
                                      <v-select
                                        :items="warrantyDurationTypes"
                                        dense
                                        filled
                                        v-model.trim="
                                          asset.preventive_duration_type
                                        "
                                        solo
                                        flat
                                        class="pl-2 pr-2 width-100"
                                        placeholder="Duration Type"
                                        color="cyan"
                                        item-text="text"
                                        item-value="value"
                                        item-color="cyan"
                                        v-on:change="
                                          (e) =>
                                            updatePreventiveDuration(
                                              e,
                                              'warranty_duration_type'
                                            )
                                        "
                                        :disabled="
                                          equipmentId > 0 ? true : false
                                        "
                                      ></v-select>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Start Date
                                      </label>
                                      <DatePicker
                                        solo
                                        flat
                                        :nullable="true"
                                        placeholder="Start Date"
                                        v-model="asset.preventive_start_date"
                                        :default-date="
                                          asset.preventive_start_date
                                        "
                                        :disabled="dateDisable()"
                                        :rules="[
                                          validateRules.required(
                                            asset.preventive_start_date,
                                            'preventive_start_date'
                                          ),
                                        ]"
                                        v-on:change="
                                          (e) =>
                                            updatePreventiveDuration(
                                              e,
                                              'preventive_start_date'
                                            )
                                        "
                                        :offWeekend="false"
                                      ></DatePicker>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >End Date</label
                                      >
                                      <div class="pl-2 pr-2 width-100">
                                        <DatePicker
                                          solo
                                          flat
                                          :nullable="true"
                                          placeholder="End Date"
                                          v-model="asset.preventive_end_date"
                                          :default-date="
                                            asset.preventive_end_date
                                          "
                                          :min-date="
                                            asset.preventive_start_date
                                          "
                                          :disabled="dateDisable()"
                                          :rules="[
                                            validateRules.required(
                                              asset.preventive_end_date,
                                              'preventive_end_date'
                                            ),
                                          ]"
                                          v-on:change="
                                            (e) =>
                                              updatePreventiveDuration(
                                                e,
                                                'preventive_end_date'
                                              )
                                          "
                                          :offWeekend="false"
                                        ></DatePicker>
                                      </div>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col lg="12">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >Maintenance Cost</label
                                      >
                                      <v-text-field
                                        type="number"
                                        id="cost1"
                                        v-model.trim.number="
                                          asset.preventive_cost
                                        "
                                        dense
                                        filled
                                        placeholder="Cost"
                                        solo
                                        flat
                                        color="cyan"
                                        class="pr-2 width-100"
                                        :disabled="
                                          equipmentId > 0 ? true : false
                                        "
                                        :min="0"
                                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57) || event.charCode==46)"
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <!-- <template
                                      v-if="
                                        asset &&
                                        asset.maintenance_reminder &&
                                        asset.maintenance_reminder.length > 0
                                      "
                                    >
                                      <template
                                        v-for="(
                                          data, index
                                        ) in asset.maintenance_reminder"
                                      >
                                        <v-row
                                          :key="`file-row-${index}`"
                                          :class="{
                                            'table-alternate-row': index % 2,
                                          }"
                                        >
                                          <v-col md="12" class="py-0">
                                            <label
                                              class="pr-2 pl-2 mt-3 font-weight-700 font-size-16 width-100"
                                              >Reminder {{ index + 1 }}</label
                                            >
                                          </v-col>
                                          <v-col md="10" class="py-0">
                                            <v-row>
                                              <v-col md="12" class="py-0">
                                                <v-layout>
                                                  <v-flex md4>
                                                    <v-radio-group
                                                      hide-details
                                                      id="export-type"
                                                      class="pt-0"
                                                      v-model="data.type"
                                                      v-on:change="
                                                        manageReminder(
                                                          index,
                                                          'maintenance'
                                                        )
                                                      "
                                                      row
                                                    >
                                                      <v-radio
                                                        label="After"
                                                        :value="0"
                                                        color="cyan"
                                                      ></v-radio>
                                                      <v-radio
                                                        label="Before"
                                                        :value="1"
                                                        color="cyan"
                                                      ></v-radio>
                                                    </v-radio-group>
                                                  </v-flex>
                                                  <v-flex md4>
                                                    <v-text-field
                                                      id="duration"
                                                      v-model.trim="data.duration"
                                                      dense
                                                      filled
                                                      label="Duration"
                                                      solo
                                                      flat
                                                      color="cyan"
                                                      class="pr-2 width-100"
                                                      v-on:keyup="
                                                        manageReminder(
                                                          index,
                                                          'maintenance'
                                                        )
                                                      "
                                                    ></v-text-field>
                                                  </v-flex>
                                                  <v-flex md4>
                                                    <v-autocomplete
                                                      :items="durationTypeList"
                                                      dense
                                                      filled
                                                      color="cyan"
                                                      item-color="cyan"
                                                      label="Duration Type"
                                                      solo
                                                      flat
                                                      item-text="text"
                                                      item-value="text"
                                                      class="pl-2 width-100"
                                                      v-on:change="
                                                        manageReminder(
                                                          index,
                                                          'maintenance'
                                                        )
                                                      "
                                                      v-model.trim="
                                                        data.duration_type
                                                      "
                                                    >
                                                    </v-autocomplete>
                                                  </v-flex>
                                                </v-layout>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                          <v-col md="2" class="my-auto py-0">
                                            <v-row>
                                              <v-col md="6" class="py-0">
                                                <v-btn
                                                  :disabled="
                                                    asset.maintenance_reminder
                                                      .length < 2
                                                  "
                                                  v-on:click="
                                                    removeMaintenanceReminder(
                                                      index
                                                    )
                                                  "
                                                  class="white--text"
                                                  depressed
                                                  color="red darken-4"
                                                  tile
                                                  style="margin-left: -10px"
                                                >
                                                  <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                              </v-col>
                                              <v-col md="6" class="py-0">
                                                <v-btn
                                                  :disabled="
                                                    asset.maintenance_reminder
                                                      .length > 4
                                                  "
                                                  v-on:click="
                                                    addMoreMaintenanceReminder()
                                                  "
                                                  class="white--text"
                                                  depressed
                                                  color="cyan"
                                                  tile
                                                  style="margin-left: -13px"
                                                >
                                                  <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </v-row>
                                      </template>
                                    </template> -->

                                  <v-row>
                                    <v-col lg="12">
                                      <label
                                        class="pr-2 pl-2 font-weight-700 font-size-16 width-100"
                                        >Description</label
                                      >
                                      <TextAreaField
                                        auto-grow
                                        dense
                                        filled
                                        color="cyan"
                                        v-model.trim="
                                          asset.preventive_description
                                        "
                                        placeholder="Description"
                                        solo
                                        flat
                                        row-height="25"
                                        counter="200"
                                      />
                                    </v-col>
                                  </v-row>

                                  <v-row>
                                    <v-col lg="12">
                                      <div class="pr-2">
                                        <FileUpload v-model="mtx_attachments">
                                        </FileUpload>
                                      </div>
                                      <template
                                        v-if="
                                          false &&
                                          mtx_attachments &&
                                          mtx_attachments.length > 0
                                        "
                                      >
                                        <template
                                          v-for="(
                                            file, indexFile
                                          ) in mtx_attachments"
                                        >
                                          <v-row
                                            :key="`maintanance-file-row-${indexFile}`"
                                            :class="{
                                              'table-alternate-row':
                                                indexFile % 2,
                                            }"
                                          >
                                            <v-col md="12" class="py-0">
                                              <label
                                                class="pr-2 pl-2 mt-3 font-weight-700 font-size-16 width-100"
                                                >Attachment</label
                                              >
                                            </v-col>
                                            <v-col md="10" class="py-0">
                                              <v-row>
                                                <v-col md="12" class="py-0">
                                                  <v-layout>
                                                    <v-flex md6>
                                                      <v-file-input
                                                        :id="`maintanance-document-file-${indexFile}`"
                                                        placeholder="Select File"
                                                        class="removeShadow"
                                                        prepend-icon=""
                                                        dense
                                                        solo
                                                        prepend-inner-icon="mdi-attachment"
                                                        hide-details
                                                        v-model="file.file"
                                                        v-on:change="
                                                          updateFileMaintanance(
                                                            indexFile,
                                                            $event
                                                          )
                                                        "
                                                        v-on:click:clear="
                                                          updateFileMaintanance(
                                                            indexFile,
                                                            $event
                                                          )
                                                        "
                                                      ></v-file-input>
                                                    </v-flex>
                                                    <v-flex md6>
                                                      <v-text-field
                                                        :id="`document-name-${indexFile}`"
                                                        v-model="file.name"
                                                        dense
                                                        filled
                                                        placeholder="File Name"
                                                        solo
                                                        flat
                                                        color="cyan"
                                                        class="pr-2 width-100"
                                                      ></v-text-field>
                                                    </v-flex>
                                                  </v-layout>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                            <v-col md="2" class="my-auto py-0">
                                              <v-row>
                                                <v-col md="6" class="py-0">
                                                  <v-btn
                                                    :disabled="
                                                      mtx_attachments.length < 2
                                                    "
                                                    v-on:click="
                                                      removeFileMaintanance(
                                                        indexFile
                                                      )
                                                    "
                                                    class="white--text"
                                                    depressed
                                                    color="red darken-4"
                                                    tile
                                                    style="margin-left: -10px"
                                                  >
                                                    <v-icon>mdi-delete</v-icon>
                                                  </v-btn>
                                                </v-col>
                                                <v-col md="6" class="py-0">
                                                  <v-btn
                                                    :disabled="
                                                      mtx_attachments.length >
                                                        4 || equipmentId > 0
                                                    "
                                                    v-on:click="
                                                      addMoreMaintanance()
                                                    "
                                                    class="white--text"
                                                    depressed
                                                    color="cyan"
                                                    tile
                                                    style="margin-left: -13px"
                                                  >
                                                    <v-icon>mdi-plus</v-icon>
                                                  </v-btn>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                        </template>
                                      </template>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-container>
                          </perfect-scrollbar>
                        </v-col>
                      </v-row>
                    </v-layout>
                  </v-col>
                </v-layout>
              </v-tab-item>
              <v-tab-item
                :value="'tab-attachments'"
                v-if="assetTab == 'tab-attachments'"
              >
                <v-row>
                  <v-col cols="12" lg="12" md="12">
                    <v-card
                      v-if="false"
                      flat
                      class="custom-grey-border remove-border-radius"
                    >
                      <v-card-title class="headline grey lighten-4">
                        <h3
                          class="font-weight-700 custom-headline color-custom-blue"
                        ></h3>
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <FileUpload v-model="wtz_attachments"></FileUpload>
                      </v-card-text>
                    </v-card>
                    <DocumnetList
                      v-model="wtz_attachments"
                      tag-type="asset"
                      :document-type="docType"
                    >
                    </DocumnetList>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item :value="'tab-motor'">
                <v-row>
                  <v-col
                    class="custom-content-container py-0"
                    cols="12"
                    :md="12"
                    :sm="12"
                  >
                    <div class="d-block customer-create-new-customer">
                      <v-row class="mx-0">
                        <v-col
                          class="iv-custom-field py-0 px-0"
                          cols="12"
                          md="12"
                          sm="12"
                        >
                          <perfect-scrollbar
                            :options="{ suppressScrollX: true }"
                            class="scroll"
                            style="max-height: 75vh; position: relative"
                          >
                            <v-container fluid>
                              <!-- Elevator Information Card -->
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius mb-4"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    Elevator Information
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Address</label
                                      >
                                      <v-text-field
                                        id="Address"
                                        v-model.trim="asset.address"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Address"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Lift Number</label
                                      >
                                      <v-text-field
                                        id="LiftNo"
                                        v-model.trim="asset.lift_number"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Lift Number"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Door Size</label
                                      >
                                      <v-text-field
                                        id="DoorSize"
                                        v-model.trim="asset.door_size"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Door Size"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Lift Type</label
                                      >
                                      <v-text-field
                                        id="LeftType"
                                        v-model.trim="asset.lift_type"
                                        dense
                                        filled
                                        :loading="formLoading"
                                        placeholder="Lift Type"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Interconnected Door Floor</label
                                      >
                                      <v-text-field
                                        id="InterconnectedDoorFloor"
                                        v-model.trim="
                                          asset.interconnected_door_floor
                                        "
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Interconnected Door Floor"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Lift Brand</label
                                      >
                                      <v-text-field
                                        id="LiftBrand"
                                        v-model.trim="asset.lift_brand"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Lift Brand"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <div class="d-flex justify-space-between">
                                        <label
                                          class="pr-2 font-weight-700 font-size-16 width-100"
                                          id="drive-system"
                                          >Drive System</label
                                        >
                                        <v-icon
                                          @click="
                                            opendialogs('driveSystemDialog')
                                          "
                                          small
                                          >mdi-cog</v-icon
                                        >
                                      </div>
                                      <v-autocomplete
                                        hide-details
                                        id="drive-system"
                                        :items="driveSystemList"
                                        :loading="formLoading"
                                        dense
                                        flat
                                        filled
                                        :placeholder="placeholder"
                                        item-color="cyan"
                                        v-model="asset.drive_system"
                                        color="cyan"
                                        solo
                                        item-text="value"
                                        item-value="value"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-title
                                              >No Drive System(s)
                                              Found.</v-list-item-title
                                            >
                                          </v-list-item>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Machine Room</label
                                      >
                                      <v-text-field
                                        id="MachineRoom"
                                        v-model.trim="asset.machine_room"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Machine Room"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Control System</label
                                      >
                                      <v-text-field
                                        id="ControlSystem"
                                        v-model.trim="asset.control_system"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Control System"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Rated Load</label
                                      >
                                      <v-text-field
                                        id="RatedLoad"
                                        v-model.trim="asset.rated_load"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Rated Load"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                      >
                                        Model</label
                                      >
                                      <v-text-field
                                        id="Model"
                                        v-model.trim="asset.elevator_model"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Model"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Rated Speed</label
                                      >
                                      <v-text-field
                                        id="RatedSpeed"
                                        v-model.trim="asset.rated_speed"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Rated Speed"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Travel Distance</label
                                      >
                                      <v-text-field
                                        id="TravelDistance"
                                        v-model.trim="asset.travel_distance"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Travel Distance"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Number of Stops</label
                                      >
                                      <v-text-field
                                        id="NumberOfStops"
                                        v-model.trim="asset.number_of_stops"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Number of Stops"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Top Clearance</label
                                      >
                                      <v-text-field
                                        id="TopClearance"
                                        v-model.trim="asset.top_clearance"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Top Clearance"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Bottom Clearance</label
                                      >
                                      <v-text-field
                                        id="BottomClearance"
                                        v-model.trim="asset.bottom_clearance"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Bottom Clearance"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>

                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Installation Date</label
                                      >
                                      <DatePicker
                                        id="InstallationDate"
                                        v-model="
                                          asset.elevator_installation_date
                                        "
                                        :loading="formLoading"
                                        dense
                                        :default-date="
                                          asset.elevator_installation_date
                                        "
                                        color="cyan"
                                        placeholder="Installation Date"
                                        filled
                                        solo
                                        flat
                                        class="width-100"
                                      ></DatePicker>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >PTO Date</label
                                      >
                                      <DatePicker
                                        id="PTODate"
                                        placeholder="PTO Date"
                                        :default-date="asset.elevator_pto_date"
                                        :loading="formLoading"
                                        v-model="asset.elevator_pto_date"
                                        dense
                                        filled
                                        solo
                                        color="cyan"
                                        flat
                                        class="width-100"
                                      ></DatePicker>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>

                              <!-- Motor Information Card -->
                              <v-card
                                flat
                                class="custom-grey-border remove-border-radius"
                              >
                                <v-card-title class="headline grey lighten-4">
                                  <h3
                                    class="font-weight-700 custom-headline color-custom-blue"
                                  >
                                    Motor Information
                                  </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                  <v-row>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Brand</label
                                      >
                                      <v-text-field
                                        id="Brand"
                                        v-model.trim="asset.elevator_brand"
                                        dense
                                        filled
                                        :loading="formLoading"
                                        placeholder="Brand"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Encoder Model</label
                                      >
                                      <v-text-field
                                        id="EncoderModel"
                                        v-model.trim="asset.encoder_model"
                                        dense
                                        filled
                                        :loading="formLoading"
                                        placeholder="Encoder Model"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Traction Radio</label
                                      >
                                      <v-text-field
                                        id="TractionRadio"
                                        v-model.trim="asset.traction_radio"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Traction Radio"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Number of Rope</label
                                      >
                                      <v-text-field
                                        id="NumberOfRope"
                                        v-model.trim="asset.number_of_rope"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Number of Rope"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Rope Diameter</label
                                      >
                                      <v-text-field
                                        id="RopeDiameter"
                                        v-model.trim="asset.rope_diameter"
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Rope Diameter"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col lg="6">
                                      <label
                                        class="pr-2 font-weight-700 font-size-16 width-100"
                                        >Main Sheave Diameter</label
                                      >
                                      <v-text-field
                                        id="MainSheaveDiameter"
                                        v-model.trim="
                                          asset.main_sheave_diameter
                                        "
                                        :loading="formLoading"
                                        dense
                                        filled
                                        placeholder="Main Sheave Diameter"
                                        solo
                                        flat
                                        color="cyan"
                                        class="width-100"
                                      ></v-text-field>
                                    </v-col>

                                    <v-col lg="6">
                                      <div class="d-flex justify-space-between">
                                        <label
                                          class="pr-2 font-weight-700 font-size-16 width-100"
                                          id="type-of-machine"
                                          >Type of Machine</label
                                        >
                                        <v-icon
                                          @click="
                                            opendialogs(
                                              'openTypeOfMachineDialog'
                                            )
                                          "
                                          small
                                          >mdi-cog</v-icon
                                        >
                                      </div>
                                      <v-autocomplete
                                        hide-details
                                        id="type-of-machine"
                                        :items="typeOfMachineList"
                                        :loading="formLoading"
                                        dense
                                        flat
                                        filled
                                        placeholder="Select Type of Machine"
                                        item-color="cyan"
                                        v-model="asset.type_of_machine"
                                        color="cyan"
                                        solo
                                        item-text="value"
                                        item-value="value"
                                      >
                                        <template v-slot:no-data>
                                          <v-list-item>
                                            <v-list-item-title
                                              >No Type of Machine(s)
                                              Found.</v-list-item-title
                                            >
                                          </v-list-item>
                                        </template>
                                      </v-autocomplete>
                                    </v-col>

                                    <!-- settings fields for units -->
                                    <v-col lg="6">
                                      <div class="d-flex flex-column">
                                        <div class="d-flex">
                                          <label
                                            class="font-weight-700 font-size-16 mb-2"
                                            id="ratePower"
                                          >
                                            Rated Power/Unit</label
                                          >

                                          <v-spacer></v-spacer>

                                          <v-icon
                                            @click="
                                              opendialogs(
                                                'openRatePowerTypeDialog'
                                              )
                                            "
                                            small
                                            class="mb-2"
                                          >
                                            mdi-cog
                                          </v-icon>
                                        </div>

                                        <div class="d-flex align-center">
                                          <v-col cols="9" class="pa-1 pr-1">
                                            <v-text-field
                                              id="ratePower"
                                              v-model.trim="asset.rated_power"
                                              dense
                                              filled
                                              :loading="formLoading"
                                              placeholder="Rated Power"
                                              solo
                                              flat
                                              color="cyan"
                                            ></v-text-field>
                                          </v-col>

                                          <v-col
                                            cols="3"
                                            class="d-flex align-center pa-0"
                                          >
                                            <v-autocomplete
                                              hide-details
                                              :items="ratePowerType"
                                              dense
                                              flat
                                              filled
                                              :placeholder="placeholder"
                                              item-color="cyan"
                                              v-model="asset.rated_power_type"
                                              :loading="formLoading"
                                              color="cyan"
                                              solo
                                              item-text="value"
                                              item-value="value"
                                              class="flex-grow-1"
                                            >
                                              <template v-slot:no-data>
                                                <v-list-item>
                                                  <v-list-item-title
                                                    >No Type
                                                    Found.</v-list-item-title
                                                  >
                                                </v-list-item>
                                              </template>
                                            </v-autocomplete>
                                          </v-col>
                                        </div>
                                      </div>
                                    </v-col>

                                    <v-col lg="6">
                                      <div class="d-flex flex-column">
                                        <div class="d-flex">
                                          <label
                                            class="font-weight-700 font-size-16 mb-2"
                                            id="rateVoltage"
                                          >
                                            Rated Voltage/Unit
                                          </label>
                                          <v-spacer></v-spacer>

                                          <v-icon
                                            @click="
                                              opendialogs(
                                                'openRateVoltageTypeDialog'
                                              )
                                            "
                                            small
                                            class="ml-2"
                                          >
                                            mdi-cog
                                          </v-icon>
                                        </div>

                                        <div class="d-flex align-center">
                                          <v-col cols="9" class="pa-1 pr-1">
                                            <v-text-field
                                              id="rateVoltage"
                                              v-model.trim="asset.rated_voltage"
                                              dense
                                              :loading="formLoading"
                                              filled
                                              placeholder="Rate Voltage"
                                              solo
                                              flat
                                              color="cyan"
                                            ></v-text-field>
                                          </v-col>

                                          <v-col
                                            cols="3"
                                            class="d-flex align-center pa-0"
                                          >
                                            <v-autocomplete
                                              hide-details
                                              :items="rateVoltageType"
                                              dense
                                              flat
                                              filled
                                              :placeholder="placeholder"
                                              item-color="cyan"
                                              :loading="formLoading"
                                              v-model="asset.rated_voltage_type"
                                              color="cyan"
                                              solo
                                              item-text="value"
                                              item-value="value"
                                              class="flex-grow-1"
                                            >
                                              <template v-slot:no-data>
                                                <v-list-item>
                                                  <v-list-item-title
                                                    >No Type
                                                    Found.</v-list-item-title
                                                  >
                                                </v-list-item>
                                              </template>
                                            </v-autocomplete>
                                          </v-col>
                                        </div>
                                      </div>
                                    </v-col>

                                    <v-col lg="6">
                                      <div class="d-flex flex-column">
                                        <div class="d-flex">
                                          <label
                                            class="font-weight-700 font-size-16 mb-2"
                                            id="rateCurrent"
                                          >
                                            Rated current/Unit
                                          </label>
                                          <v-spacer></v-spacer>
                                          <v-icon
                                            @click="
                                              opendialogs(
                                                'openRateCurrentTypeDialog'
                                              )
                                            "
                                            small
                                            class="ml-2"
                                          >
                                            mdi-cog
                                          </v-icon>
                                        </div>

                                        <div class="d-flex align-center">
                                          <v-col cols="9" class="pa-1 pr-1">
                                            <v-text-field
                                              id="rateCurrent"
                                              v-model.trim="asset.rated_current"
                                              dense
                                              :loading="formLoading"
                                              filled
                                              placeholder="Rate Current"
                                              solo
                                              flat
                                              color="cyan"
                                            ></v-text-field>
                                          </v-col>

                                          <v-col
                                            cols="3"
                                            class="d-flex align-center pa-0"
                                          >
                                            <v-autocomplete
                                              hide-details
                                              :items="rateCurrentType"
                                              dense
                                              flat
                                              filled
                                              :placeholder="placeholder"
                                              item-color="cyan"
                                              :loading="formLoading"
                                              v-model="asset.rated_current_type"
                                              color="cyan"
                                              solo
                                              item-text="value"
                                              item-value="value"
                                              class="flex-grow-1"
                                            >
                                              <template v-slot:no-data>
                                                <v-list-item>
                                                  <v-list-item-title
                                                    >No Type
                                                    Found.</v-list-item-title
                                                  >
                                                </v-list-item>
                                              </template>
                                            </v-autocomplete>
                                          </v-col>
                                        </div>
                                      </div>
                                    </v-col>

                                    <v-col lg="6">
                                      <div class="d-flex flex-column">
                                        <div class="d-flex">
                                          <label
                                            class="font-weight-700 font-size-16 mb-2"
                                            id="frequency"
                                          >
                                            Frequency/Unit
                                          </label>
                                          <v-spacer></v-spacer>
                                          <v-icon
                                            @click="
                                              opendialogs('frequencyTypeDialog')
                                            "
                                            small
                                            class="ml-2"
                                          >
                                            mdi-cog
                                          </v-icon>
                                        </div>

                                        <div class="d-flex align-center">
                                          <v-col cols="9" class="pa-1 pr-1">
                                            <v-text-field
                                              id="frequency"
                                              v-model.trim="asset.frequency"
                                              dense
                                              filled
                                              placeholder="Frequency"
                                              solo
                                              flat
                                              color="cyan"
                                              :loading="formLoading"
                                            ></v-text-field>
                                          </v-col>

                                          <v-col
                                            cols="3"
                                            class="d-flex align-center pa-0"
                                          >
                                            <v-autocomplete
                                              hide-details
                                              :items="frequencyType"
                                              dense
                                              flat
                                              filled
                                              placeholder="Frequency Unit"
                                              item-color="cyan"
                                              v-model="asset.frequency_type"
                                              color="cyan"
                                              solo
                                              :loading="formLoading"
                                              item-text="value"
                                              item-value="value"
                                              class="flex-grow-1"
                                            >
                                              <template v-slot:no-data>
                                                <v-list-item>
                                                  <v-list-item-title
                                                    >No Type
                                                    Found.</v-list-item-title
                                                  >
                                                </v-list-item>
                                              </template>
                                            </v-autocomplete>
                                          </v-col>
                                        </div>
                                      </div>
                                    </v-col>

                                    <v-col lg="6">
                                      <div class="d-flex flex-column">
                                        <div class="d-flex">
                                          <label
                                            class="font-weight-700 font-size-16 mb-2"
                                            id="EncodeShaftDiameter"
                                          >
                                            Encode Shaft Diameter/Unit
                                          </label>
                                          <v-spacer></v-spacer>
                                          <v-icon
                                            @click="
                                              opendialogs(
                                                'encodeShaftDiameterTypeDialog'
                                              )
                                            "
                                            small
                                            class="ml-2"
                                          >
                                            mdi-cog
                                          </v-icon>
                                        </div>
                                        <div class="d-flex align-center">
                                          <v-col cols="9" class="pa-1 pr-1">
                                            <v-text-field
                                              id="EncodeShaftDiameter"
                                              v-model.trim="
                                                asset.encode_shaft_diameter
                                              "
                                              dense
                                              filled
                                              :loading="formLoading"
                                              placeholder="Encode Shaft Diameter"
                                              solo
                                              flat
                                              color="cyan"
                                            ></v-text-field>
                                          </v-col>

                                          <v-col
                                            cols="3"
                                            class="d-flex align-center pa-0"
                                          >
                                            <v-autocomplete
                                              hide-details
                                              :items="encodeShaftDiameterType"
                                              dense
                                              flat
                                              filled
                                              placeholder="Encode shaft Diameter Unit"
                                              item-color="cyan"
                                              v-model="
                                                asset.encode_shaft_diameter_type
                                              "
                                              color="cyan"
                                              solo
                                              :loading="formLoading"
                                              item-text="value"
                                              item-value="value"
                                              class="flex-grow-1"
                                            >
                                              <template v-slot:no-data>
                                                <v-list-item>
                                                  <v-list-item-title
                                                    >No Type
                                                    Found.</v-list-item-title
                                                  >
                                                </v-list-item>
                                              </template>
                                            </v-autocomplete>
                                          </v-col>
                                        </div>
                                      </div>
                                    </v-col>

                                    <v-col lg="6">
                                      <div class="d-flex flex-column">
                                        <div class="d-flex">
                                          <label
                                            class="font-weight-700 font-size-16 mb-2"
                                            id="ratedRotationalSpeed"
                                          >
                                            Rated Rotational Speed/Unit
                                          </label>
                                          <v-spacer></v-spacer>
                                          <v-icon
                                            @click="
                                              opendialogs(
                                                'ratedRotationalSpeedTypeDialog'
                                              )
                                            "
                                            small
                                            class="ml-2"
                                          >
                                            mdi-cog
                                          </v-icon>
                                        </div>

                                        <div class="d-flex align-center">
                                          <v-col cols="9" class="pa-1 pr-1">
                                            <v-text-field
                                              id="ratedRotationalSpeed"
                                              v-model.trim="
                                                asset.rated_rotational_speed
                                              "
                                              dense
                                              filled
                                              placeholder="Encode Shaft Diameter"
                                              solo
                                              flat
                                              color="cyan"
                                              :loading="formLoading"
                                            ></v-text-field>
                                          </v-col>

                                          <v-col
                                            cols="3"
                                            class="d-flex align-center pa-0"
                                          >
                                            <v-autocomplete
                                              hide-details
                                              :items="ratedRotationalSpeedType"
                                              dense
                                              flat
                                              filled
                                              placeholder="Rated Rotational Speed Type"
                                              item-color="cyan"
                                              v-model="
                                                asset.rated_rotational_speed_type
                                              "
                                              color="cyan"
                                              solo
                                              :loading="formLoading"
                                              item-text="value"
                                              item-value="value"
                                              class="flex-grow-1"
                                            >
                                              <template v-slot:no-data>
                                                <v-list-item>
                                                  <v-list-item-title
                                                    >No Type
                                                    Found.</v-list-item-title
                                                  >
                                                </v-list-item>
                                              </template>
                                            </v-autocomplete>
                                          </v-col>
                                        </div>
                                      </div>
                                    </v-col>
                                    <!-- settings fields for units -->
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-container>
                          </perfect-scrollbar>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item :value="'tab-elevator-elements'">
                <v-row>
                  <v-col cols="12">
                    <v-card
                      flat
                      class="custom-grey-border remove-border-radius"
                    >
                      <v-card-title class="headline grey lighten-4">
                        <h3
                          class="font-weight-700 custom-headline color-custom-blue"
                        >
                          Speed Governor Information
                        </h3>
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <!-- Speed Governor -->
                        <v-row>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Speed Governor Brand</label
                            >
                            <v-text-field
                              id="Brand"
                              v-model.trim="asset.speed_governor_brand"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Brand"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Speed Governor Rated Speed</label
                            >
                            <v-text-field
                              id="Rated Speed"
                              v-model.trim="asset.speed_governor_rated_speed"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Rated Speed"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Speed Governor Model</label
                            >
                            <v-text-field
                              id="Model"
                              v-model.trim="asset.speed_governor_model"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Model"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Speed Governor Rope Diameter</label
                            >
                            <v-text-field
                              id="Rope Diameter"
                              v-model.trim="asset.speed_governor_rope_diameter"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Rope Diameter"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Speed Governor Installation Date</label
                            >
                            <DatePicker
                              v-model="asset.speed_governor_installation_date"
                              dense
                              color="cyan"
                              filled
                              placeholder="Installation Date"
                            ></DatePicker>
                          </v-col>
                          <v-col lg="6">
                            <div class="d-flex justify-space-between">
                              <label
                                class="pr-2 font-weight-700 font-size-16 width-100"
                                id="tensioning-mechanism"
                                >Tensioning Mechanism</label
                              >
                              <v-icon
                                @click="
                                  opendialogs('tensioningMechanismDialog')
                                "
                                small
                                >mdi-cog</v-icon
                              >
                            </div>
                            <v-autocomplete
                              hide-details
                              id="tensioning-mechanism"
                              :items="tensioningMechanismList"
                              dense
                              flat
                              filled
                              placeholder="Select Tensioning Mechanism"
                              item-color="cyan"
                              :loading="formLoading"
                              v-model="asset.tensioning_mechanism"
                              color="cyan"
                              solo
                              item-text="value"
                              item-value="value"
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-title
                                    >No Tensioning Mechanism(s)
                                    Found.</v-list-item-title
                                  >
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>

                          <v-col lg="6" v-if="false">
                            <label class="font-weight-700 font-size-16"
                              >Speed Governor Tensioning Mechanism</label
                            >
                            <v-text-field
                              id="Tensioning Mechanism"
                              v-model.trim="
                                asset.speed_governor_tensioning_mechanism
                              "
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Tensioning Mechanism"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Elevator Car -->
                        <v-card-title class="headline grey lighten-4 mt-4">
                          <h3
                            class="font-weight-700 custom-headline color-custom-blue"
                          >
                            Elevator Car Information
                          </h3>
                        </v-card-title>
                        <v-row>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Size of Car</label
                            >
                            <v-text-field
                              id="Size"
                              v-model.trim="asset.size_of_car"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Size of Car"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Control Board</label
                            >
                            <v-text-field
                              id="Control Board"
                              v-model.trim="asset.control_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Control Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Height of Car</label
                            >
                            <v-text-field
                              id="Height of Car"
                              v-model.trim="asset.height_of_car"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Height of Car"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Lighting System</label
                            >
                            <v-text-field
                              id="Lighting System"
                              v-model.trim="asset.lighting_of_system"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Lighting System"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <div class="d-flex justify-space-between">
                              <label
                                class="pr-2 font-weight-700 font-size-16 width-100"
                                id="type-of-car-door"
                                >Type of Car Door</label
                              >
                              <v-icon
                                @click="opendialogs('openTypeOfCarDoorDialog')"
                                small
                                >mdi-cog</v-icon
                              >
                            </div>
                            <v-autocomplete
                              hide-details
                              id="type-of-car-door"
                              :items="typeOfCarDoorList"
                              dense
                              flat
                              filled
                              placeholder="Select Type of Car Door"
                              item-color="cyan"
                              :loading="formLoading"
                              v-model="asset.type_of_car_door"
                              color="cyan"
                              solo
                              item-text="value"
                              item-value="value"
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-title
                                    >No Type of Car Door(s)
                                    Found.</v-list-item-title
                                  >
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>

                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Ventilation System</label
                            >
                            <v-text-field
                              id="Ventilation System"
                              v-model.trim="asset.ventilation_system"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Ventilation System"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Car Door Width</label
                            >
                            <v-text-field
                              id="Door Width"
                              v-model.trim="asset.car_door_width"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Door Width"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Car Door Height</label
                            >
                            <v-text-field
                              id="Car Door Height"
                              v-model.trim="asset.car_door_height"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Car Door Height"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Safety Device</label
                            >
                            <v-text-field
                              id="Safety Device"
                              v-model.trim="asset.car_safety_device"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Safety Device"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>

                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Internal Display Board</label
                            >
                            <v-text-field
                              id="Internal Display Board"
                              v-model.trim="asset.car_internal_display_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Internal Display Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Model of Button</label
                            >
                            <v-text-field
                              id="Model of Button"
                              v-model.trim="asset.car_model_of_button"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Model of Button"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >External Display Board</label
                            >
                            <v-text-field
                              id="External Display Board"
                              v-model.trim="asset.car_external_display_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="External Display Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="12">
                            <label class="font-weight-700 font-size-16"
                              >Remark</label
                            >
                            <TextAreaField
                              auto-grow
                              dense
                              filled
                              color="cyan"
                              v-model.trim="asset.elevator_car_remark"
                              placeholder="Remark"
                              solo
                              flat
                              row-height="20"
                              counter="200"
                            />
                          </v-col>
                        </v-row>

                        <!-- Door Operator -->
                        <v-card-title class="headline grey lighten-4 mt-4">
                          <h3
                            class="font-weight-700 custom-headline color-custom-blue"
                          >
                            Door Operator Information
                          </h3>
                        </v-card-title>
                        <v-row>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Door Operator Model</label
                            >
                            <v-text-field
                              id="Door Operator Model"
                              v-model.trim="asset.door_operator_model"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Door Operator Model"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>

                          <v-col lg="6">
                            <div class="d-flex flex-column">
                              <div class="d-flex">
                                <label
                                  class="font-weight-700 font-size-16 mb-2"
                                  id="ratePower"
                                >
                                  Door Operator Rated Power/Unit</label
                                >
                                <v-spacer></v-spacer>
                                <v-icon
                                  @click="
                                    opendialogs('ratePowerDoorTypeDialog')
                                  "
                                  small
                                  class="mb-2"
                                >
                                  mdi-cog
                                </v-icon>
                              </div>

                              <div class="d-flex align-center">
                                <v-col cols="9" class="pa-1 pr-1">
                                  <v-text-field
                                    id="ratePower"
                                    v-model.trim="
                                      asset.door_operator_rated_power
                                    "
                                    dense
                                    filled
                                    :loading="formLoading"
                                    placeholder="Rated Power"
                                    solo
                                    flat
                                    color="cyan"
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="3"
                                  class="d-flex align-center pa-0"
                                >
                                  <v-autocomplete
                                    hide-details
                                    :items="ratePowerDoorType"
                                    dense
                                    flat
                                    filled
                                    placeholder="Power Unit"
                                    item-color="cyan"
                                    v-model="
                                      asset.door_operator_rated_power_unit
                                    "
                                    :loading="formLoading"
                                    color="cyan"
                                    solo
                                    item-text="value"
                                    item-value="value"
                                    class="flex-grow-1 mb-1"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Type Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </div>
                            </div>
                          </v-col>

                          <v-col lg="6">
                            <div class="d-flex flex-column">
                              <div class="d-flex">
                                <label
                                  class="font-weight-700 font-size-16 mb-2"
                                  id="rateVoltage"
                                >
                                  Door Operator Rated Voltage/Unit
                                </label>
                                <v-spacer></v-spacer>

                                <v-icon
                                  @click="
                                    opendialogs('rateVoltageDoorTypeDialog')
                                  "
                                  small
                                  class="ml-2"
                                >
                                  mdi-cog
                                </v-icon>
                              </div>
                              <div class="d-flex align-center">
                                <v-col cols="9" class="pa-1 pr-1">
                                  <v-text-field
                                    class="mb-1"
                                    id="rateVoltage"
                                    v-model.trim="
                                      asset.door_operator_rated_voltage
                                    "
                                    dense
                                    :loading="formLoading"
                                    filled
                                    placeholder="Rated Voltage"
                                    solo
                                    flat
                                    color="cyan"
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="3"
                                  class="d-flex align-center pa-0"
                                >
                                  <v-autocomplete
                                    hide-details
                                    :items="rateVoltageDoorType"
                                    dense
                                    flat
                                    filled
                                    placeholder="Voltage Unit"
                                    item-color="cyan"
                                    :loading="formLoading"
                                    v-model="
                                      asset.door_operator_rated_voltage_unit
                                    "
                                    color="cyan"
                                    solo
                                    item-text="value"
                                    item-value="value"
                                    class="flex-grow-1 mb-1"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Type Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </div>
                            </div>
                          </v-col>

                          <v-col lg="6">
                            <div class="d-flex flex-column">
                              <div class="d-flex">
                                <label
                                  class="font-weight-700 font-size-16 mb-2"
                                  id="rateCurrent"
                                >
                                  Door Operator Rated Current/Unit
                                </label>
                                <v-spacer></v-spacer>
                                <v-icon
                                  @click="
                                    opendialogs('rateCurrentDoorTypeDialog')
                                  "
                                  small
                                  class="ml-2"
                                >
                                  mdi-cog
                                </v-icon>
                              </div>

                              <div class="d-flex align-center">
                                <v-col cols="9" class="pa-1 pr-1">
                                  <v-text-field
                                    id="rateCurrent"
                                    v-model.trim="
                                      asset.door_operator_rated_current
                                    "
                                    dense
                                    :loading="formLoading"
                                    filled
                                    placeholder="Rated Current"
                                    solo
                                    flat
                                    color="cyan"
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="3"
                                  class="d-flex align-center pa-0"
                                >
                                  <v-autocomplete
                                    hide-details
                                    :items="rateCurrentDoorType"
                                    dense
                                    flat
                                    filled
                                    placeholder="Current Unit"
                                    item-color="cyan"
                                    :loading="formLoading"
                                    v-model="
                                      asset.door_operator_rated_current_unit
                                    "
                                    color="cyan"
                                    solo
                                    item-text="value"
                                    item-value="value"
                                    class="flex-grow-1 mb-1"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Type Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </div>
                            </div>
                          </v-col>

                          <v-col lg="6">
                            <div class="d-flex flex-column">
                              <div class="d-flex">
                                <label
                                  class="font-weight-700 font-size-16 mb-2"
                                  id="frequency"
                                >
                                  Door Operator Rated Frequency/Unit
                                </label>
                                <v-spacer></v-spacer>
                                <v-icon
                                  @click="
                                    opendialogs('frequencyDoorTypeDialog')
                                  "
                                  small
                                  class="ml-2"
                                >
                                  mdi-cog
                                </v-icon>
                              </div>
                              <div class="d-flex align-center">
                                <v-col cols="9" class="pa-1 pr-1">
                                  <v-text-field
                                    id="frequency"
                                    v-model.trim="
                                      asset.door_operator_rated_frequency
                                    "
                                    dense
                                    filled
                                    placeholder="Frequency"
                                    solo
                                    flat
                                    color="cyan"
                                    :loading="formLoading"
                                  ></v-text-field>
                                </v-col>

                                <v-col
                                  cols="3"
                                  class="d-flex align-center pa-0"
                                >
                                  <v-autocomplete
                                    hide-details
                                    :items="frequencyDoorType"
                                    dense
                                    flat
                                    filled
                                    placeholder="Frequency Unit"
                                    item-color="cyan"
                                    v-model="
                                      asset.door_operator_rated_frequency_unit
                                    "
                                    color="cyan"
                                    solo
                                    :loading="formLoading"
                                    item-text="value"
                                    item-value="value"
                                    class="flex-grow-1 mb-1"
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <v-list-item-title
                                          >No Type Found.</v-list-item-title
                                        >
                                      </v-list-item>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </div>
                            </div>
                          </v-col>

                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Door Operator Rope Belt</label
                            >
                            <v-text-field
                              id="Door Operator Rope Belt"
                              v-model.trim="asset.door_operator_rope_belt"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Door Operator Rope Belt"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Door Wheel Model 1</label
                            >
                            <v-text-field
                              id="Wheel Model"
                              v-model.trim="asset.door_wheel_model"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Wheel Model"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Door Wheel Model 2</label
                            >
                            <v-text-field
                              id="Wheel Model"
                              v-model.trim="asset.door_wheel_model_2"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Wheel Model"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Model of Door Strike</label
                            >
                            <v-text-field
                              id="Door Strike"
                              v-model.trim="asset.model_of_door_strike"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Door Strike"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Door Lock Model</label
                            >
                            <v-text-field
                              id="Door Lock"
                              v-model.trim="asset.door_lock_model"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Door Lock"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Control Panel -->
                        <v-card-title class="headline grey lighten-4 mt-4">
                          <h3
                            class="font-weight-700 custom-headline color-custom-blue"
                          >
                            Control Panel Information
                          </h3>
                        </v-card-title>
                        <v-row>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Main Controller Board</label
                            >

                            <v-text-field
                              id="Main Controller Board"
                              v-model.trim="asset.main_controller_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Main Controller Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Safety Circuit Board</label
                            >

                            <v-text-field
                              id="Safety Circuit Board"
                              v-model.trim="asset.safety_circuit_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Safety Circuit Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Control Panel Inverter</label
                            >

                            <v-text-field
                              id="Control Panel Inverter"
                              v-model.trim="asset.control_panel_inverter"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Control Panel Inverter"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Power Supply Board</label
                            >
                            <v-text-field
                              id="Power Supply Board"
                              v-model.trim="asset.power_supply_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Power Supply Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Door Controller Board</label
                            >
                            <v-text-field
                              id="Door Controller Board"
                              v-model.trim="asset.door_controller_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Door Controller Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Expansion Board</label
                            >
                            <v-text-field
                              id="Expansion Board"
                              v-model.trim="asset.expansion_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Expansion Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Comm Board</label
                            >
                            <v-text-field
                              id="Comm Board"
                              v-model.trim="asset.comm_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Comm Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                          <v-col lg="6">
                            <label class="font-weight-700 font-size-16"
                              >Display Board</label
                            >
                            <v-text-field
                              id="Display Board"
                              v-model.trim="asset.display_board"
                              :loading="formLoading"
                              dense
                              filled
                              placeholder="Display Board"
                              solo
                              flat
                              color="cyan"
                              class="width-100"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-form>
      <ManageMotorSettings
        :m-dialog="systemDialog"
        :settings="thelist"
        :title="title"
        :value="value"
        :endpoint="endpoint"
        @close-dialog="closedialogs"
        @get-settings="get_options"
      />

      <ManageUnitSettings
        :m-dialog="unitDialog"
        :settings="thelist"
        :title="title"
        :type="type"
        :product_type="product_type"
        :value="value"
        @close-dialog="closeUnitDialog"
        @get-settings="get_options"
      />

      <ManageBrand
        :b-dialog="manage_brand"
        :brand="brands"
        Equipment
        v-on:close-dialog="manage_brand = false"
        v-on:get-product-brand="get_options"
      ></ManageBrand>
      <ManageEquipmentLocation
        :dialog="manage_location"
        :equipment="equipment_locations"
        v-on:close-dialog="manage_location = false"
        v-on:get-equipment-location="get_options"
      ></ManageEquipmentLocation>
      <template v-if="manageGroupDialog">
        <ManageCategory
          Equipment
          :c-dialog="manageGroupDialog"
          :category="categoryList"
          v-on:close-dialog="manageGroupDialog = false"
          v-on:get-product-category="get_options"
        ></ManageCategory>
      </template>
      <AddCertisDialog
        :product-type="'equipment'"
        :related-id="equipmentId"
        :product-dialog="addCert_dialog"
        v-on:update-values="addSkills"
        v-on:close="addCert_dialog = false"
        :updated-data="asset.skills_carts"
      >
      </AddCertisDialog>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  POST,
  CLEAR_ERROR,
  GET,
  QUERY,
} from "@/core/services/store/request.module";
import AddCertisDialog from "@/view/components/AddCertisDialog.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { cloneDeep, findIndex, toSafeInteger /*  filter  */ } from "lodash";
import {
  /* SET_MESSAGE, */ SET_ERROR,
} from "@/core/services/store/common.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CustomerMixin from "@/core/plugins/customer-mixin";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import TagAutoComplete from "@/view/pages/partials/TagAutoCompleteInput";
import ManageCategory from "@/view/pages/partials/Manage-Product-Category.vue";
import DatePicker from "@/view/components/DatePicker.vue";
import MomentJS from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import ManageBrand from "@/view/pages/partials/Manage-Product-Brand.vue";
//import FileUpload from "@/view/components/app-component/FileInput.vue";
import DocumnetList from "@/view/pages/DocumnetList";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";

import ManageEquipmentLocation from "@/view/pages/partials/Manage-Equipment-Location.vue";
import ManageMotorSettings from "@/view/pages/partials/Manage-Motor-Settings.vue";
import ManageUnitSettings from "@/view/pages/partials/Manage-Unit-Settings.vue";
export default {
  mixins: [CommonMixin, ValidationMixin, CustomerMixin, FileManagerMixin],
  name: "customer-create",
  title: "Create Asset",
  //emits: ['phone-number'],
  data() {
    return {
      placeholder: "",
      title: "",
      value: "",
      type: "",
      product_type: "",
      endpoint: "",
      thelist: [],
      docType: 37,
      filteredProduct: {
        category_name: null,
        model: null,
        name: null,
        description: null,
        serial_number: null,
        product_image: null,
        brand: null,
        model_no: null,
      },
      unique_barcode: null,
      leadId: 0,
      addCert_dialog: false,
      imageLoading: false,
      customerList: [],
      formValid: true,
      formLoading: false,
      manage_brand: false,
      manage_location: false,
      show_location: null,
      files: [
        {
          file: null,
          name: null,
          remark: null,
          suffix: null,
          tags: null,
          search: null,
          start_date: null,
          end_date: null,
          reminder_date: null,
        },
      ],
      equipment_files: [
        {
          file: null,
          name: null,
          remark: null,
          suffix: null,
          tags: null,
          search: null,
          start_date: null,
          end_date: null,
          reminder_date: null,
        },
      ],
      durationTypeList: [
        {
          text: "Day(s)",
          value: "day",
        },
        {
          text: "Month(s)",
          value: "month",
        },
        {
          text: "Year(s)",
          value: "year",
        },
      ],
      lead: {},
      minDate: null,
      categoryList: [],
      equipmentId: 0,
      manageGroupDialog: false,
      propertyAddress: {},
      billingAddress: {},
      all_customers: [],
      all_property: [],
      brands: [],
      products: [],
      supplierList: [],
      equipment_locations: [],
      sub_locations: [],
      filtered_property: [],
      contactDetail: {},
      contactPerson: [],
      notification: {},
      updatedImg: null,
      siteLocationList: [],
      asset: {
        salesperson: null,
        purchase_price: null,
        purchase_date: null,
        quotation_no: null,
        invoice_no: null,
        arrival_date: null,
        site_location: 0,
        specification: null,
        machine_number: null,
        supplier: null,
        do_no: null,
        common_cert_no: null,
        sales_employee: null,
        delivery_date: null,
        delivery_remark: null,
        selling_price: 0,
        batch_number: null,
        check_maintanance: false,
        skills_carts: [],
        /* preventive_duration_type: "month",
          preventive_start_date: MomentJS().format("YYYY-MM-DD"),
          preventive_end_date: null,
          preventive_duration: 0,
          preventive_description: null, */
        asset_type: "company",
        name: null,
        main_type: "main_company",
        customer: 0,
        brand: null,
        installation_date: null,
        activation_date: null,
        property: 0,
        product: 0,
        asset_image: null,
        category: null,
        pico_barcode: null,
        serial_no: null,
        location: 0,
        model: null,
        check_warranty: false,
        is_return: false,
        is_purchase_info: false,
        description: null,
        tags: [],
        warranty_start_date: null,
        warranty_end_date: null,
        warranty_duration: 1,
        warranty_duration_type: "month",
        warranty_cost: 0,
        warranty_remark: null,
        warranty_reference: null,
        warranty_reminder: [
          {
            type: "after",
            duration: null,
            duration_type: "Day",
            reminder_type: null,
          },
        ],
        company_number: null,
        address: "",
        elevator_brand: "",
        lift_number: "",
        door_size: "",
        lift_type: "",
        interconnected_door_floor: "",
        lift_brand: "",
        machine_room: "",
        control_system: "",
        rated_load: "",
        elevator_model: "",
        rated_speed: "",
        travel_distance: "",
        number_of_stops: "",
        top_clearance: "",
        bottom_clearance: "",
        encoder_model: "",
        traction_radio: "",
        number_of_rope: "",
        rope_diameter: "",
        main_sheave_diameter: "",
        elevator_installation_date: "",
        elevator_pto_date: "",
        drive_system: "",
        type_of_machine: "",
        tensioning_mechanism: "",
        type_of_car_door: "",

        rated_power: "",
        rated_power_type: "",
        rated_voltage: "",
        rated_voltage_type: "",
        rated_current: "",
        rated_current_type: "",
        frequency: "",
        frequency_type: "",
        encode_shaft_diameter: "",
        encode_shaft_diameter_type: "",
        rated_rotational_speed: "",
        rated_rotational_speed_type: "",

        // adding more fields
        speed_governor_brand: "",
        speed_governor_rated_speed: "",
        speed_governor_model: "",
        speed_governor_rope_diameter: "",
        speed_governor_installation_date: "",
        speed_governor_tensioning_mechanism: "",

        size_of_car: "",
        control_board: "",
        height_of_car: "",
        lighting_of_system: "",
        ventilation_system: "",
        car_door_width: "",
        car_door_height: "",
        car_safety_device: "",
        elevator_car_remark: "",
        car_internal_display_board: "",
        car_model_of_button: "",
        car_external_display_board: "",

        door_operator_model: "",
        door_operator_rated_power: "",

        door_operator_rated_power_unit: "",
        door_operator_rated_current: "",
        door_operator_rated_current_unit: "",
        door_operator_rated_frequency: "",
        door_operator_rated_frequency_unit: "",
        door_operator_rope_belt: "",
        door_wheel_model: "",
        door_wheel_model_2: "",
        model_of_door_strike: "",
        door_lock_model: "",

        main_controller_board: "",
        safety_circuit_board: "",
        control_panel_inverter: "",
        power_supply_board: "",
        door_controller_board: "",
        expansion_board: "",
        comm_board: "",
        display_board: "",
      },
      warrantyDurationTypes: [
        {
          text: "Day(s)",
          value: "day",
        },
        {
          text: "Month(s)",
          value: "month",
        },
        {
          text: "Year(s)",
          value: "year",
        },
      ],
      wtz_attachments: Array({
        file: null,
        url: null,
        name: null,
      }),
      wtx_attachments: Array({
        file: null,
        url: null,
        name: null,
      }),
      mtx_attachments: Array({
        file: null,
        url: null,
        name: null,
      }),
      tabs: [
        {
          title: "Overview",
          icon: "mdi-format-list-bulleted",
          key: "overview",
          permission: "customer",
          status: true,
        },
        {
          title: "Allocate Details",
          icon: "mdi-account-multiple",
          key: "allocate-details",
          permission: "contact-person",
          status: false,
        },
        {
          title: "Warranty Details",
          icon: "mdi-home-map-marker",
          key: "warranty",
          permission: "contact-person",
          status: true,
        },
        {
          title: "Preventive Maintenance",
          icon: "mdi-credit-card",
          key: "preventive-maintanance",
          permission: "property",
          status: true,
        },
        {
          title: "Elevator/Motor Info",
          icon: "mdi-state-machine",
          key: "motor",
          permission: "customer",
          status: true,
        },
        {
          title: "Elevator/Elements Info",
          icon: "mdi-relation-one-to-many",
          key: "elevator-elements",
          permission: "customer",
          status: true,
        },
        {
          title: "Attachments",
          icon: "mdi-file",
          key: "attachments",
          permission: "customer",
          status: true,
        },
        /*   {
            title: "Maintenance Details",
            icon: "mdi-credit-card",
            key: "maintenance",
            permission: "customer",
            status: true,
          }, */
      ],
      assetTab: "tab-overview",
      isCustomerCreated: false,
      isAddressCreated: false,
      options: {},
      steps: {
        details: false,
        "contact-person": true,
        property: true,
        maintenance: true,
        notification: true,
      },
      companyEquipmentType: "tool",
      unitDialog: false,
      currentUnitType: "",
      unitSettingsData: {
        rated_power_type: {
          title: "Power Rate Type",
          items: this.ratePowerType,
        },
        rated_voltage_type: {
          title: "Voltage Rate Type",
          items: this.rateVoltageType,
        },
        rated_current_type: {
          title: "Current Rate Type",
          items: this.rateCurrentType,
        },
        frequency_type: {
          title: "Frequency Units",
          items: this.frequencyType,
        },
        encode_shaft_diameter_type: {
          title: "Shaft Diameter Units",
          items: this.encodeShaftDiameterType,
        },
        rated_rotational_speed: {
          title: "Rotational Speed Units",
          items: this.ratedRotationalSpeedType,
        },
      },
      systemDialog: false,

      ratePowerType: [],
      rateVoltageType: [],
      rateCurrentType: [],
      frequencyType: [],
      encodeShaftDiameterType: [],
      ratedRotationalSpeedType: [],

      driveSystemList: [],
      typeOfMachineList: [],
      tensioningMechanismList: [],
      typeOfCarDoorList: [],

      ratePowerDoorType: [],
      rateVoltageDoorType: [],
      rateCurrentDoorType: [],
      frequencyDoorType: [],
    };
  },
  props: {
    isCustomer: {
      type: Boolean,
      default: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    PhoneTextField,
    TagAutoComplete,
    CreateUpdateTemplate,
    ManageCategory,
    DatePicker,
    ManageBrand,
    Barcode,
    ManageEquipmentLocation,
    //FileUpload,
    TextAreaField,
    AddCertisDialog,
    DocumnetList,
    ManageMotorSettings,
    ManageUnitSettings,
  },
  watch: {
    assetTab() {
      const _this = this;
      setTimeout(function () {
        _this.$refs.assetForm.validate();
      }, 200);
    },
    formValid(param) {
      if (param) {
        this.$store.dispatch(CLEAR_ERROR, {});
      }
    },

    /* customerId:{
        deep:true,
        immediate : true,
        handler(param) {
          if(param){
            this.filter_property(param)
          }
        }
      } */
  },
  methods: {
    getDates() {
      if (!this.asset?.installation_date || !this.asset?.end_life) {
        return false;
      }

      let date1 = new Date(this.asset?.installation_date);
      let date2 = new Date(this.asset?.end_life);

      if (isNaN(date1) || isNaN(date2)) {
        return "Invalid date format.";
      }

      let years = date2.getFullYear() - date1.getFullYear();
      let months = date2.getMonth() - date1.getMonth();
      let days = date2.getDate() - date1.getDate();

      if (days < 0) {
        months--;
        days += new Date(date2.getFullYear(), date2.getMonth(), 0).getDate();
      }

      if (months < 0) {
        years--;
        months += 12;
      }
      let result = [];
      if (years > 0) result.push(`${years} year${years > 1 ? "s" : ""}`);
      if (months > 0) result.push(`${months} month${months > 1 ? "s" : ""}`);
      if (days > 0) result.push(`${days} day${days > 1 ? "s" : ""}`);

      return result.length > 0 ? `${result.join(", ")}` : "-";
    },
    getLocation(id) {
      let checkData = this.lodash.find(this.all_property, { id: id });
      this.show_location = checkData;
    },
    addSkills(data) {
      let selectedCarts = data;
      this.asset.skills_carts = selectedCarts;
      /*  selectedCarts.map((row) => {
         this.productCreate.skills_carts.push(row);
           }
       ); */
    },
    removeCert(index) {
      this.asset.skills_carts.splice(index, 1);
    },
    getDisabled(row) {
      if (
        this.moduleType &&
        this.moduleType == 7 &&
        row?.preventive_id > 0 &&
        row?.item_count > 0
      ) {
        return true;
      }
      return false;
    },
    goToDefaultDetail(data) {
      if (this.companyEquipmentType == "asset") {
        this.$router.push(
          this.getDefaultRoute("asset-equipment.detail", {
            params: { id: data.id },
            query: { equip_type: "asset" },
          })
        );
      }

      if (this.companyEquipmentType == "sale") {
        this.$router.push(
          this.getDefaultRoute("sale-equipment.detail", {
            params: { id: data.id },
            query: { equip_type: "sale" },
          })
        );
      }

      if (this.companyEquipmentType == "tool" || !this.companyEquipmentType) {
        this.$router.push(
          this.getDefaultRoute("equipment.detail", {
            params: { id: data.id },
            query: { equip_type: "tool" },
          })
        );
      }
    },
    getEquipTypeText() {
      if (this.companyEquipmentType == "asset") {
        return "Asset";
      }
      if (this.companyEquipmentType == "sale") {
        return "Sale";
      }
      return "Tool";
    },
    dateDisable() {
      if (this.equipmentId > 0) {
        return true;
      } else {
        return false;
      }
    },

    checkType() {
      if (this.asset.main_type == "main_company") {
        this.asset.asset_type = "company";
      } else {
        this.asset.asset_type = "personal";
      }
    },
    productData(product) {
      if (product > 0) {
        let filtered_product = this.lodash.filter(this.products, {
          id: product,
        });
        this.filteredProduct.product_image = filtered_product[0].product_image;
        // }
        this.setProductData(product);
        //console.log(this.filteredProduct);
        this.asset.name = filtered_product[0].name;
        this.asset.brand = filtered_product[0].brand;
        this.asset.serial_no = null; //filtered_product[0].barcode
        this.asset.category = filtered_product[0].category;
        this.asset.warranty_duration_type = filtered_product[0].duration_time;
        this.asset.warranty_duration = filtered_product[0].warranty_check;
      }
    },
    setProductData(product = 0) {
      if (product > 0) {
        let filtered_product = this.lodash.filter(this.products, {
          id: product,
        });
        if (filtered_product) {
          this.filteredProduct.category_name = filtered_product[0].category;
          this.filteredProduct.model = filtered_product[0].model;
          this.filteredProduct.name = filtered_product[0].name;
          this.filteredProduct.description = filtered_product[0].description;
          this.filteredProduct.serial_number = filtered_product[0].barcode; //changed from serial_number
          this.filteredProduct.product_image =
            filtered_product[0].product_image;
          this.filteredProduct.brand = filtered_product[0].brand;
          this.filteredProduct.model = filtered_product[0].model;
          this.filteredProduct.model_no = filtered_product[0].model_no;
        }
      }
    },
    get_formatted_property(row) {
      let tempArr = [];
      if (row.unit_no) {
        tempArr.push(row.unit_no);
      }
      if (row.street_1) {
        tempArr.push(row.street_1);
      }
      if (row.street_2) {
        tempArr.push(row.street_2);
      }
      if (row.zip_code) {
        tempArr.push(row.zip_code);
      }
      if (row.country_name) {
        tempArr.push(row.country_name);
      }
      return tempArr.join(", ");
    },

    get_Equipment() {
      this.formLoading = true;
      this.$store
        .dispatch(GET, { url: `equipment/${this.equipmentId}` })
        .then(({ data }) => {
          this.unique_barcode = data.barcode;

          (this.updatedImg = data.image ? data.image : null),
            (this.asset.asset_type = data.type ? data.type : null);
          this.asset.name = data.name ? data.name : null;
          this.asset.main_type = data.main_type ? data.main_type : null;
          this.asset.end_life = data.end_life ? data.end_life : null;
          this.asset.company_number = data.company_number
            ? data.company_number
            : null;
          this.asset.customer =
            data.customer && data.customer.id ? data.customer.id : 0;
          this.asset.property =
            data.property && data.property.id ? data.property.id : 0;
          this.filter_property(this.asset.customer);
          this.asset.brand = data.brand ? data.brand : null;
          this.asset.installation_date = data.installation_date
            ? data.installation_date
            : null;
          this.asset.activation_date = data.activation_date
            ? data.activation_date
            : null;
          this.asset.product = data.product ? data.product : 0;
          this.asset.site_location = data.site_location
            ? data.site_location.id
            : 0;
          this.getLocation(this.asset.site_location);
          this.asset.category = data.category ? data.category : null;

          this.asset.skills_carts = data.certificates ? data.certificates : [];
          this.asset.specification = data.specification
            ? data.specification
            : null;
          this.asset.machine_number = data.machine_number
            ? data.machine_number
            : null;
          this.asset.salesperson = data.salesperson ? data.salesperson : null;
          this.asset.purchase_price = data.purchase_price
            ? data.purchase_price
            : null;
          this.asset.purchase_date = data.purchase_date
            ? data.purchase_date
            : null;
          this.asset.invoice_no = data.invoice_no ? data.invoice_no : null;
          this.asset.quotation_no = data.quotation_no
            ? data.quotation_no
            : null;
          this.asset.arrival_date = data.arrival_date
            ? data.arrival_date
            : null;
          if (this.asset.product) {
            this.setProductData(this.asset.product);
          }
          // if(filtered_product){
          // this.filteredProduct.category_name = data.category ? data.category : null;
          // this.filteredProduct.model = data.model ? data.model : null;
          // this.filteredProduct.name = data.category ? data.category : null;
          // this.filteredProduct.description = filtered_product[0].description;
          // this.filteredProduct.serial_number = filtered_product[0].serial_number;
          // this.filteredProduct.product_image = filtered_product[0].product_image;
          // }

          /*    this.asset.asset_image = data.asset_image ? data.asset_image : null; */
          this.asset.model = data.model ? data.model : null;
          this.asset.location =
            data.location && data.location.id
              ? this.lodash.toString(data.location.id)
              : null;

          this.asset.serial_no = data.serial_no ? data.serial_no : null;

          this.asset.check_warranty = data.has_warranty;
          this.changeWarrantyCheck(this.asset.check_warranty);

          this.asset.check_maintanance =
            data.has_preventive_maintanance == "0" ||
            data.has_preventive_maintanance == 0
              ? 0
              : 1;
          this.changeMaintananceCheck(this.asset.check_maintanance);

          this.asset.is_purchase_info = data.is_purchase_info
            ? data.is_purchase_info
            : 0;
          this.asset.purchased_on = data.purchased_on
            ? data.purchased_on
            : null;
          this.asset.cost_price = data.cost_price ? data.cost_price : 0;
          this.asset.vendor =
            data.supplier && data.supplier.id ? data.supplier.id : 0;

          this.asset.description = data.description ? data.description : null;
          this.asset.tags =
            data.asset_tags /*  && data.tags.length ? data.tags : [] */;
          this.asset.warranty_start_date =
            data.warranty && data.warranty.start_date
              ? data.warranty.start_date
              : null;
          this.asset.warranty_end_date =
            data.warranty && data.warranty.end_date
              ? data.warranty.end_date
              : null;
          this.asset.warranty_duration_type =
            data.warranty && data.warranty.duration_type
              ? data.warranty.duration_type
              : null;
          this.asset.warranty_duration =
            data.warranty && data.warranty.duration
              ? data.warranty.duration
              : 0;
          this.asset.warranty_cost =
            data.warranty && data.warranty.cost ? data.warranty.cost : 0;
          this.asset.warranty_reference =
            data.warranty && data.warranty.reference
              ? data.warranty.reference
              : null;
          this.asset.warranty_remark =
            data.warranty && data.warranty.remark ? data.warranty.remark : null;
          //preventive set details
          this.asset.preventive_start_date =
            data.preventive_maintanance &&
            data.preventive_maintanance.start_date
              ? data.preventive_maintanance.start_date
              : null;
          this.asset.preventive_end_date =
            data.preventive_maintanance && data.preventive_maintanance.end_date
              ? data.preventive_maintanance.end_date
              : null;
          this.asset.preventive_duration_type =
            data.preventive_maintanance &&
            data.preventive_maintanance.duration_type
              ? data.preventive_maintanance.duration_type
              : null;
          this.asset.preventive_duration =
            data.preventive_maintanance && data.preventive_maintanance.duration
              ? data.preventive_maintanance.duration
              : 0;
          this.asset.preventive_cost =
            data.preventive_maintanance && data.preventive_maintanance.cost
              ? data.preventive_maintanance.cost
              : 0;
          this.asset.preventive_description =
            data.preventive_maintanance && data.preventive_maintanance.remark
              ? data.preventive_maintanance.remark
              : null;
          this.asset.batch_number =
            data && data.batch_number ? data.batch_number : null;
          this.asset.selling_price =
            data && data.selling_price ? data.selling_price : null;

          this.asset.asset_image = data.image;

          this.asset.do_no = data.do_no ? data.do_no : null;
          this.asset.common_cert_no = data.common_cert_no
            ? data.common_cert_no
            : null;
          this.asset.sales_employee = data.sales_employee
            ? data.sales_employee
            : null;
          this.asset.delivery_date = data.delivery_date
            ? data.delivery_date
            : null;
          this.asset.delivery_remark = data.delivery_remark
            ? data.delivery_remark
            : null;

          // adding new columns here
          this.asset.address = data.address ? data.address : null;
          this.asset.elevator_brand = data.elevator_brand
            ? data.elevator_brand
            : null;
          this.asset.lift_number = data.lift_number ? data.lift_number : null;
          this.asset.door_size = data.door_size ? data.door_size : null;
          this.asset.lift_type = data.lift_type ? data.lift_type : null;

          this.asset.interconnected_door_floor = data.interconnected_door_floor
            ? data.interconnected_door_floor
            : null;

          this.asset.lift_brand = data.lift_brand ? data.lift_brand : null;
          this.asset.machine_room = data.machine_room
            ? data.machine_room
            : null;
          this.asset.control_system = data.control_system
            ? data.control_system
            : null;
          this.asset.rated_load = data.rated_load ? data.rated_load : null;
          this.asset.elevator_model = data.elevator_model
            ? data.elevator_model
            : null;

          this.asset.rated_speed = data.rated_speed ? data.rated_speed : null;
          this.asset.travel_distance = data.travel_distance
            ? data.travel_distance
            : null;
          this.asset.number_of_stops = data.number_of_stops
            ? data.number_of_stops
            : null;
          this.asset.top_clearance = data.top_clearance
            ? data.top_clearance
            : null;
          this.asset.bottom_clearance = data.bottom_clearance
            ? data.bottom_clearance
            : null;
          this.asset.encoder_model = data.encoder_model
            ? data.encoder_model
            : null;
          this.asset.traction_radio = data.traction_radio
            ? data.traction_radio
            : null;

          this.asset.number_of_rope = data.number_of_rope
            ? data.number_of_rope
            : null;
          this.asset.rope_diameter = data.rope_diameter
            ? data.rope_diameter
            : null;
          this.asset.main_sheave_diameter = data.main_sheave_diameter
            ? data.main_sheave_diameter
            : null;
          this.asset.elevator_installation_date =
            data.elevator_installation_date
              ? data.elevator_installation_date
              : null;

          this.asset.elevator_pto_date = data.elevator_pto_date
            ? data.elevator_pto_date
            : null;

          this.asset.drive_system = data.drive_system
            ? data.drive_system
            : null;

          this.asset.type_of_machine = data.type_of_machine
            ? data.type_of_machine
            : null;

          this.asset.tensioning_mechanism = data.tensioning_mechanism
            ? data.tensioning_mechanism
            : null;
          this.asset.type_of_car_door = data.type_of_car_door
            ? data.type_of_car_door
            : null;
          this.asset.rated_power = data.rated_power ? data.rated_power : null;
          this.asset.rated_power_type = data.rated_power_type
            ? data.rated_power_type
            : null;
          this.asset.rated_voltage = data.rated_voltage
            ? data.rated_voltage
            : null;
          this.asset.rated_voltage_type = data.rated_voltage_type
            ? data.rated_voltage_type
            : null;
          this.asset.rated_current = data.rated_current
            ? data.rated_current
            : null;
          this.asset.rated_current_type = data.rated_current_type
            ? data.rated_current_type
            : null;
          this.asset.frequency = data.frequency ? data.frequency : null;
          this.asset.frequency_type = data.frequency_type
            ? data.frequency_type
            : null;
          this.asset.encode_shaft_diameter = data.encode_shaft_diameter
            ? data.encode_shaft_diameter
            : null;
          this.asset.encode_shaft_diameter_type =
            data.encode_shaft_diameter_type
              ? data.encode_shaft_diameter_type
              : null;
          this.asset.rated_rotational_speed = data.rated_rotational_speed
            ? data.rated_rotational_speed
            : null;
          this.asset.rated_rotational_speed_type =
            data.rated_rotational_speed_type
              ? data.rated_rotational_speed_type
              : null;

          this.asset.speed_governor_brand = data.speed_governor_brand
            ? data.speed_governor_brand
            : null;
          this.asset.speed_governor_rated_speed =
            data.speed_governor_rated_speed
              ? data.speed_governor_rated_speed
              : null;
          this.asset.speed_governor_model = data.speed_governor_model
            ? data.speed_governor_model
            : null;
          this.asset.speed_governor_rope_diameter =
            data.speed_governor_rope_diameter
              ? data.speed_governor_rope_diameter
              : null;
          this.asset.speed_governor_installation_date =
            data.speed_governor_installation_date
              ? data.speed_governor_installation_date
              : null;
          this.asset.speed_governor_tensioning_mechanism =
            data.speed_governor_tensioning_mechanism
              ? data.speed_governor_tensioning_mechanism
              : null;

          this.asset.size_of_car = data.size_of_car ? data.size_of_car : null;
          this.asset.control_board = data.control_board
            ? data.control_board
            : null;
          this.asset.height_of_car = data.height_of_car
            ? data.height_of_car
            : null;
          this.asset.lighting_of_system = data.lighting_of_system
            ? data.lighting_of_system
            : null;
          this.asset.ventilation_system = data.ventilation_system
            ? data.ventilation_system
            : null;
          this.asset.car_door_width = data.car_door_width
            ? data.car_door_width
            : null;
          this.asset.car_door_height = data.car_door_height
            ? data.car_door_height
            : null;
          this.asset.car_safety_device = data.car_safety_device
            ? data.car_safety_device
            : null;
          this.asset.elevator_car_remark = data.elevator_car_remark
            ? data.elevator_car_remark
            : null;
          this.asset.car_internal_display_board =
            data.car_internal_display_board
              ? data.car_internal_display_board
              : null;
          this.asset.car_model_of_button = data.car_model_of_button
            ? data.car_model_of_button
            : null;
          this.asset.car_external_display_board =
            data.car_external_display_board
              ? data.car_external_display_board
              : null;

          this.asset.door_operator_model = data.door_operator_model
            ? data.door_operator_model
            : null;
          this.asset.door_operator_rated_power = data.door_operator_rated_power
            ? data.door_operator_rated_power
            : null;
          this.asset.door_operator_rated_power_unit =
            data.door_operator_rated_power_unit
              ? data.door_operator_rated_power_unit
              : null;
          this.asset.door_operator_rated_current =
            data.door_operator_rated_current
              ? data.door_operator_rated_current
              : null;
          this.asset.door_operator_rated_current_unit =
            data.door_operator_rated_current_unit
              ? data.door_operator_rated_current_unit
              : null;
          this.asset.door_operator_rated_voltage =
            data.door_operator_rated_voltage
              ? data.door_operator_rated_voltage
              : null;
          this.asset.door_operator_rated_voltage_unit =
            data.door_operator_rated_voltage_unit
              ? data.door_operator_rated_voltage_unit
              : null;
          this.asset.door_operator_rated_frequency =
            data.door_operator_rated_frequency
              ? data.door_operator_rated_frequency
              : null;
          this.asset.door_operator_rated_frequency_unit =
            data.door_operator_rated_frequency_unit
              ? data.door_operator_rated_frequency_unit
              : null;
          this.asset.door_operator_rope_belt = data.door_operator_rope_belt
            ? data.door_operator_rope_belt
            : null;
          this.asset.door_wheel_model = data.door_wheel_model
            ? data.door_wheel_model
            : null;
          this.asset.door_wheel_model_2 = data.door_wheel_model_2
            ? data.door_wheel_model_2
            : null;
          this.asset.model_of_door_strike = data.model_of_door_strike
            ? data.model_of_door_strike
            : null;
          this.asset.door_lock_model = data.door_lock_model
            ? data.door_lock_model
            : null;

          this.asset.main_controller_board = data.main_controller_board
            ? data.main_controller_board
            : null;
          this.asset.safety_circuit_board = data.safety_circuit_board
            ? data.safety_circuit_board
            : null;
          this.asset.control_panel_inverter = data.control_panel_inverter
            ? data.control_panel_inverter
            : null;
          this.asset.power_supply_board = data.power_supply_board
            ? data.power_supply_board
            : null;
          this.asset.door_controller_board = data.door_controller_board
            ? data.door_controller_board
            : null;
          this.asset.expansion_board = data.expansion_board
            ? data.expansion_board
            : null;
          this.asset.comm_board = data.comm_board ? data.comm_board : null;
          this.asset.display_board = data.display_board
            ? data.display_board
            : null;
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    get_options() {
      this.formLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "equipment/options",
          data: {
            type: "main_company",
            equip_type: this.companyEquipmentType,
          },
        })
        .then(({ data }) => {
          this.customerList = data.customers;
          this.supplierList = data.suppliers;

          (this.ratePowerDoorType = data.door_rated_power_unit_list),
            (this.rateVoltageDoorType = data.door_rated_voltage_unit_list),
            (this.rateCurrentDoorType = data.door_rated_current_unit_list),
            (this.frequencyDoorType = data.door_frequency_unit_list),
            (this.ratePowerType = data.rated_power_unit_list),
            (this.rateVoltageType = data.rated_voltage_unit_list),
            (this.rateCurrentType = data.rated_current_unit_list),
            (this.frequencyType = data.frequency_unit_list),
            (this.encodeShaftDiameterType =
              data.encode_shaft_diameter_unit_list),
            (this.ratedRotationalSpeedType =
              data.rated_rotational_speed_unit_list),
            (this.driveSystemList = data.drive_system);
          this.typeOfMachineList = data.type_of_machine;
          this.tensioningMechanismList = data.tensioning_mechanism;
          this.typeOfCarDoorList = data.type_of_car_door;
          this.all_property = data.properties;
          if (!this.equipmentId && this.customerId && this.isCustomer) {
            this.filter_property(this.customerId);
          }
          this.brands = data.brands;
          this.categoryList = data.category;
          this.products = data.products;
          this.equipment_locations = data.equipment_locations;
          if (!this.equipmentId) {
            this.unique_barcode = data && data.barcode;
          }
          //added here for site loc empty issue on update
          if (this.equipmentId > 0) {
            this.get_Equipment();
          }
          /* this.filtered_property = this.lodash.filter(this.all_property, {
              customer: this.asset.customer,
            }); */
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    filter_property(param) {
      this.filtered_property = this.lodash.filter(this.all_property, {
        customer: param,
      });
    },
    manageReminder(index, type) {
      let reminderData = cloneDeep(this.asset.maintenance_reminder);
      let endDate = this.asset.maintenance_end_date;
      if (type == "warranty") {
        reminderData = cloneDeep(this.asset.warranty_reminder);
        endDate = this.asset.warranty_end_date;
      }
      if (
        reminderData[index] &&
        reminderData[index].duration &&
        reminderData[index].duration_type &&
        endDate
      ) {
        endDate = MomentJS(endDate, "YYYY-MM-DD");
        let reminderDate = null;
        if (reminderData[index].type == 0) {
          reminderDate = endDate.subtract(
            reminderData[index].duration,
            reminderData[index].duration_type
          );
        } else {
          reminderDate = endDate.add(
            reminderData[index].duration,
            reminderData[index].duration_type
          );
        }
        if (type == "warranty") {
          this.asset.warranty_end_date[index].date =
            reminderDate.format("YYYY-MM-DD");
        }
      }
    },
    addMoreWarranty() {
      this.wtx_attachments.push({
        file: null,
        url: null,
        name: null,
      });
    },
    removeFileWarranty(index) {
      this.wtx_attachments.splice(index, 1);
      if (this.wtx_attachments.length < 1) {
        this.addMoreWarranty();
      }
    },

    addMoreEquipment() {
      this.wtz_attachments.push({
        file: null,
        url: null,
        name: null,
      });
    },
    removeFileEquipment(index) {
      this.wtz_attachments.splice(index, 1);
      if (this.wtz_attachments.length < 1) {
        this.addMoreEquipment();
      }
    },
    // addMoreMaintanance() {
    //   this.mtx_attachments.push({
    //     file: null,
    //     url: null,
    //     name: null,
    //   });
    // },
    /* removeFileMaintanance(index) {
        this.mtx_attachments.splice(index, 1);
        if (this.mtx_attachments.length < 1) {
          this.addMoreMaintanace();
        }
      },
      addMoreMaintanance() {
        this.mtx_attachments.push({
          file: null,
          url: null,
          name: null,
        });
      }, */

    // removeFileMaintenance(index) {
    //   this.mtx_attachments.splice(index, 1);
    //   if (this.mtx_attachments.length < 1) {
    //     this.addMoreWarranty();
    //   }
    // },
    updateProfileImage(param) {
      const _this = this;
      _this.imageLoading = true;
      _this
        .uploadAttachment(param)
        .then((response) => {
          let data = _this.lodash.head(response);
          _this.asset.asset_image =
            data && data.file && data.file.url ? data.file.url : null;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.imageLoading = false;
        });
    },
    selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },
    addMoreWarrantyReminder() {
      this.asset.warranty_reminder.push({
        type: 0,
        duration: null,
        duration_type: "day",
        reminder_type: null,
      });
    },
    addMoreMaintenanceReminder() {
      this.asset.maintenance_reminder.push({
        type: 0,
        duration: null,
        duration_type: "day",
        reminder_type: null,
      });
    },
    removeWarrantyReminder(index) {
      this.asset.warranty_reminder.splice(index, 1);
      if (this.asset.warranty_reminder.length < 1) {
        this.addMoreWarrantyReminder();
      }
    },
    removeMaintenanceReminder(index) {
      this.asset.maintenance_reminder.splice(index, 1);
      if (this.asset.maintenance_reminder.length < 1) {
        this.addMoreWarrantyReminder();
      }
    },
    updateWarrantyDuration(e, type) {
      let warranty_start_date = e;
      if (type != "start_date") {
        warranty_start_date =
          this.asset && this.asset.warranty_start_date
            ? this.asset.warranty_start_date
            : null;
      }
      if (warranty_start_date) {
        let { warranty_duration_type, warranty_duration } = this.asset;
        let date = MomentJS(warranty_start_date, "YYYY-MM-DD");
        let duration = warranty_duration ? toSafeInteger(warranty_duration) : 0;
        switch (warranty_duration_type) {
          case "day":
            date = MomentJS(warranty_start_date, "YYYY-MM-DD").add(
              duration,
              "d"
            );
            break;
          case "month":
            date = MomentJS(warranty_start_date, "YYYY-MM-DD").add(
              duration,
              "M"
            );
            break;
          case "year":
            date = MomentJS(warranty_start_date, "YYYY-MM-DD").add(
              duration,
              "y"
            );
            break;
        }
        this.asset.warranty_end_date = date.format("YYYY-MM-DD");
      }
    },

    updatePreventiveDuration(e, type) {
      let preventive_start_date = e;
      if (type != "start_date") {
        preventive_start_date =
          this.asset && this.asset.preventive_start_date
            ? this.asset.preventive_start_date
            : null;
      }
      if (preventive_start_date) {
        let { preventive_duration_type, preventive_duration } = this.asset;
        let date = MomentJS(preventive_start_date, "YYYY-MM-DD");
        let duration = preventive_duration
          ? toSafeInteger(preventive_duration)
          : 0;
        switch (preventive_duration_type) {
          case "day":
            date = MomentJS(preventive_start_date, "YYYY-MM-DD").add(
              duration,
              "d"
            );
            break;
          case "month":
            date = MomentJS(preventive_start_date, "YYYY-MM-DD").add(
              duration,
              "M"
            );
            break;
          case "year":
            date = MomentJS(preventive_start_date, "YYYY-MM-DD").add(
              duration,
              "y"
            );
            break;
        }
        this.asset.preventive_end_date = date.format("YYYY-MM-DD");
      }
    },

    changeWarrantyCheck(data) {
      let warrantyIndex = findIndex(this.tabs, (row) => row.key == "warranty");
      this.tabs[warrantyIndex].status = data;
    },
    changeMaintananceCheck(data) {
      // true or false

      let maintenanceIndex = findIndex(
        this.tabs,
        (row) => row.key == "preventive-maintanance"
      );
      this.tabs[maintenanceIndex].status =
        data == "0" || data == 0 ? false : true;
    },

    blockSpecialCharacters(event) {
      // Get the key code of the pressed key
      const keyCode = event.keyCode;

      // Allow alphanumeric characters (48-57: 0-9, 65-90: A-Z, 97-122: a-z)
      const isAlphanumeric =
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 65 && keyCode <= 90) ||
        (keyCode >= 97 && keyCode <= 122);

      // Allow space (32) and backspace (8)
      const isSpaceOrBackspace = keyCode === 32 || keyCode === 8;

      // If the pressed key is not alphanumeric, space, or backspace, prevent default behavior (typing)
      if (!isAlphanumeric && !isSpaceOrBackspace) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      // Prevent the default paste behavior
      event.preventDefault();

      // Get the pasted text
      const pastedText = event.clipboardData.getData("text/plain");

      // Define a regular expression to match allowed characters (letters and numbers in this example)
      const allowedCharsRegex = /[A-Za-z0-9]/g;

      // Filter out unwanted characters
      const filteredText = pastedText.match(allowedCharsRegex).join("");

      // Update the input value with the filtered text
      this.asset.serial_no = filteredText;
    },

    async updateOrCreate() {
      const _this = this;
      const formErrors = _this.validateForm(_this.$refs.assetForm);

      if (formErrors.length) {
        _this.$store.commit(SET_ERROR, _this.errors.concat(formErrors));
        return false;
      }

      if (!_this.$refs.assetForm.validate()) {
        return false;
      }

      // adding validation for checking for units and values

      // if (this.asset.rated_power_type && !this.asset.rated_power) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Rated power field is required")
      //         );
      //         return false;
      //       }

      //     if (this.asset.rated_power && !this.asset.rated_power_type) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Please specify the unit for Rated power")
      //         );
      //         return false;
      //       }
      //     if (this.asset.rated_voltage_type && !this.asset.rated_voltage) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Rated Voltage field is required")
      //         );
      //         return false;
      //       }

      //     if (this.asset.rated_voltage && !this.asset.rated_voltage_type) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Please specify the unit for Rated Voltage")
      //         );
      //         return false;
      //       }

      //       if (this.asset.rated_current_type && !this.asset.rated_current) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Rated current field is required")
      //         );
      //         return false;
      //       }

      //     if (this.asset.rated_current && !this.asset.rated_current_type) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Please specify the unit for Rated current")
      //         );
      //         return false;
      //       }

      //     if (this.asset.frequency_type && !this.asset.frequency) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Frequency field is required")
      //         );
      //         return false;
      //       }

      //     if (this.asset.frequency && !this.asset.frequency_type) {
      //       ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Please specify the unit for Frequency")
      //         );
      //         return false;
      //     }

      //     if (this.asset.encode_shaft_diameter_type && !this.asset.encode_shaft_diameter) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Encode shaft diameter field is required")
      //         );
      //         return false;
      //       }

      //     if (this.asset.encode_shaft_diameter && !this.asset.encode_shaft_diameter_type) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Please specify the unit for Encode shaft diameter.")
      //         );
      //         return false;
      //       }

      //     if (this.asset.rated_rotational_speed_type && !this.asset.rated_rotational_speed) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Rated rotational speed field is required")
      //         );
      //         return false;
      //       }
      //     if (this.asset.rated_rotational_speed && !this.asset.rated_rotational_speed_type) {
      //         ErrorEventBus.$emit(
      //           "update:error",
      //           InitializeError("Please specify the unit for Rated rotational speed.")
      //         );
      //         return false;
      //       }
      // adding validation for checking for units and values
      if (this.asset.check_warranty && !this.asset.warranty_start_date) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Warranty start date is required")
        );
        return false;
      }
      if (this.asset.check_warranty && !this.asset.warranty_end_date) {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError("Warranty end date is required")
        );
        return false;
      }
      /* let attachment = filter(_this.mtx_attachments, function(row){
          console.log(row);
          return row;
        }); */

      let formData = new FormData();
      formData.append("type", this.asset.asset_type);

      formData.append("equipment_type", this.companyEquipmentType);

      if (this.asset.main_type == "main_company") {
        formData.append("customer", 0);
        formData.append("property", 0);
      }
      if (this.asset.main_type == "main_customer") {
        formData.append(
          "customer",
          this.asset.customer ? this.asset.customer : this.customerId
        );
        formData.append(
          "property",
          this.asset.property ? this.asset.property : 0
        );
      }
      formData.append("name", this.asset.name ? this.asset.name : 0);
      formData.append(
        "serial_no",
        this.asset.serial_no ? this.asset.serial_no : null
      );
      if (this.asset && this.asset.category) {
        formData.append(
          "category",
          this.asset.category ? this.asset.category : null
        );
      }
      if (this.asset && this.asset.installation_date) {
        formData.append(
          "installation_date",
          this.asset.installation_date ? this.asset.installation_date : null
        );
      }
      if (this.asset && this.asset.activation_date) {
        formData.append(
          "activation_date",
          this.asset.activation_date ? this.asset.activation_date : null
        );
      }
      /*  if (this.asset && this.asset.main_type && !this.isCustomer) { */
      formData.append(
        "main_type",
        this.asset.main_type ? this.asset.main_type : null
      );
      /*   } */
      if (this.asset && this.asset.end_life) {
        formData.append(
          "end_life",
          this.asset.end_life ? this.asset.end_life : null
        );
      }
      if (this.asset && this.asset.company_number) {
        formData.append(
          "company_number",
          this.asset.company_number ? this.asset.company_number : null
        );
      }
      if (this.asset && this.asset.cost) {
        formData.append("cost", this.asset.cost ? this.asset.cost : 0);
      }
      if (this.asset && this.asset.location) {
        formData.append(
          "location",
          this.asset.location ? this.asset.location : 0
        );
      }
      if (this.asset && this.asset.product) {
        formData.append("product", this.asset.product ? this.asset.product : 0);
      }
      if (this.asset && this.asset.model) {
        formData.append("model", this.asset.model ? this.asset.model : null);
      }
      if (this.asset && this.asset.asset_image) {
        formData.append("asset_image", this.asset.asset_image);
      }

      if (this.asset && this.asset.brand) {
        formData.append("brand", this.asset.brand ? this.asset.brand : null);
      }
      if (this.asset && this.asset.description) {
        formData.append(
          "description",
          this.asset.description ? this.asset.description : null
        );
      }
      if (this.asset && this.asset.check_warranty) {
        formData.append("check_warranty", this.asset.check_warranty ? 1 : 0);
      }
      if (this.asset && this.asset.is_purchase_info) {
        formData.append(
          "is_purchase_info",
          this.asset.is_purchase_info ? 1 : 0
        );
      }
      if (this.asset && this.asset.is_purchase_info && this.asset.cost_price) {
        formData.append(
          "cost_price",
          this.asset.cost_price ? this.asset.cost_price : 0
        );
      }
      if (
        this.asset &&
        this.asset.is_purchase_info &&
        this.asset.purchased_on
      ) {
        formData.append(
          "purchased_on",
          this.asset.purchased_on ? this.asset.purchased_on : null
        );
      }

      //delivery info
      if (this.asset && this.asset.do_no && this.asset.do_no) {
        formData.append("do_no", this.asset.do_no ? this.asset.do_no : null);
      }
      if (
        this.asset &&
        this.asset.common_cert_no &&
        this.asset.common_cert_no
      ) {
        formData.append(
          "common_cert_no",
          this.asset.common_cert_no ? this.asset.common_cert_no : null
        );
      }
      if (
        this.asset &&
        this.asset.sales_employee &&
        this.asset.sales_employee
      ) {
        formData.append(
          "sales_employee",
          this.asset.sales_employee ? this.asset.sales_employee : null
        );
      }
      if (this.asset && this.asset.delivery_date && this.asset.delivery_date) {
        formData.append(
          "delivery_date",
          this.asset.delivery_date ? this.asset.delivery_date : null
        );
      }
      if (
        this.asset &&
        this.asset.delivery_remark &&
        this.asset.delivery_remark
      ) {
        formData.append(
          "delivery_remark",
          this.asset.delivery_remark ? this.asset.delivery_remark : null
        );
      }
      if (
        this.asset &&
        this.asset.warranty_remark &&
        this.asset.warranty_remark
      ) {
        formData.append(
          "warranty_remark",
          this.asset.warranty_remark ? this.asset.warranty_remark : null
        );
      }
      if (
        this.asset &&
        this.asset.warranty_reference &&
        this.asset.warranty_reference
      ) {
        formData.append(
          "warranty_reference",
          this.asset.warranty_reference ? this.asset.warranty_reference : null
        );
      }
      if (this.asset && this.asset.vendor) {
        formData.append("vendor", this.asset.vendor ? this.asset.vendor : 0);
      }
      if (
        this.asset &&
        this.asset.check_warranty &&
        this.asset.warranty_duration
      ) {
        formData.append(
          "warranty_duration",
          this.asset.warranty_duration ? this.asset.warranty_duration : 0
        );
      }
      if (
        this.asset &&
        this.asset.check_warranty &&
        this.asset.warranty_duration_type
      ) {
        formData.append(
          "warranty_duration_type",
          this.asset.warranty_duration_type
            ? this.asset.warranty_duration_type
            : null
        );
      }

      if (
        this.asset &&
        this.asset.check_warranty &&
        this.asset.warranty_start_date
      ) {
        formData.append(
          "warranty_start_date",
          this.asset.warranty_start_date ? this.asset.warranty_start_date : null
        );
      }
      if (
        this.asset &&
        this.asset.check_warranty &&
        this.asset.warranty_end_date
      ) {
        formData.append(
          "warranty_end_date",
          this.asset.warranty_end_date ? this.asset.warranty_end_date : null
        );
      }
      if (this.asset && this.asset.check_warranty && this.asset.warranty_cost) {
        formData.append(
          "warranty_cost",
          this.asset.warranty_cost ? this.asset.warranty_cost : 0
        );
      }

      if (
        this.asset &&
        this.asset.tags &&
        this.asset.tags.length &&
        this.asset.tags.length > 0
      ) {
        for (let i = 0; i < this.asset.tags.length; i++) {
          if (
            this.asset.tags &&
            this.asset.tags[i] &&
            this.asset.tags[i].type
          ) {
            formData.append(`tags[${i}][type]`, this.asset.tags[i].type);
          }
          if (
            this.asset.tags &&
            this.asset.tags[i] &&
            this.asset.tags[i].color
          ) {
            formData.append(`tags[${i}][color]`, this.asset.tags[i].color);
          }
          if (
            this.asset.tags &&
            this.asset.tags[i] &&
            this.asset.tags[i].text
          ) {
            formData.append(`tags[${i}][text]`, this.asset.tags[i].text);
          }
        }
      }
      if (
        this.asset &&
        this.asset.warranty_reminder &&
        this.asset.warranty_reminder.length &&
        this.asset.warranty_reminder.length > 0
      ) {
        for (let i = 0; i < this.asset.warranty_reminder.length; i++) {
          formData.append(
            `warranty_reminder[${i}][type]`,
            this.asset.warranty_reminder[i].type
              ? this.asset.warranty_reminder[i].type
              : 0
          );

          if (
            this.asset.warranty_reminder &&
            this.asset.warranty_reminder[i] &&
            this.asset.warranty_reminder[i].duration
          ) {
            formData.append(
              `warranty_reminder[${i}][duration]`,
              this.asset.warranty_reminder[i].duration
            );
          }
          if (
            this.asset.warranty_reminder &&
            this.asset.warranty_reminder[i] &&
            this.asset.warranty_reminder[i].duration_type
          ) {
            formData.append(
              `warranty_reminder[${i}][duration_type]`,
              this.asset.warranty_reminder[i].duration_type
            );
          }
          if (
            this.asset.warranty_reminder &&
            this.asset.warranty_reminder[i] &&
            this.asset.warranty_reminder[i].reminder_type
          ) {
            formData.append(
              `warranty_reminder[${i}][reminder_type]`,
              this.asset.warranty_reminder[i].reminder_type
            );
          }
        }
      }

      //preventive
      if (this.asset && this.asset.check_maintanance) {
        formData.append(
          "has_preventive_maintanance",
          this.asset.check_maintanance ? this.asset.check_maintanance : 0
        );
      }
      if (
        this.asset &&
        this.asset.check_maintanance &&
        this.asset.preventive_cost
      ) {
        formData.append(
          "preventive_cost",
          this.asset.preventive_cost ? this.asset.preventive_cost : 0
        );
      }
      if (
        this.asset &&
        this.asset.check_maintanance &&
        this.asset.preventive_description
      ) {
        formData.append(
          "preventive_description",
          this.asset.preventive_description
            ? this.asset.preventive_description
            : null
        );
      }
      if (
        this.asset &&
        this.asset.check_maintanance &&
        this.asset.preventive_end_date
      ) {
        formData.append(
          "preventive_end_date",
          this.asset.preventive_end_date ? this.asset.preventive_end_date : null
        );
      }
      if (
        this.asset &&
        this.asset.check_maintanance &&
        this.asset.preventive_start_date
      ) {
        formData.append(
          "preventive_start_date",
          this.asset.preventive_start_date
            ? this.asset.preventive_start_date
            : null
        );
      }
      if (
        this.asset &&
        this.asset.check_maintanance &&
        this.asset.preventive_duration_type
      ) {
        formData.append(
          "preventive_duration_type",
          this.asset.preventive_duration_type
            ? this.asset.preventive_duration_type
            : null
        );
      }
      if (
        this.asset &&
        this.asset.check_maintanance &&
        this.asset.preventive_duration
      ) {
        formData.append(
          "preventive_duration",
          this.asset.preventive_duration ? this.asset.preventive_duration : 0
        );
      }

      formData.append(
        "batch_number",
        this.asset.batch_number ? this.asset.batch_number : null
      );
      formData.append(
        "selling_price",
        this.asset.selling_price ? this.asset.selling_price : 0
      );

      if (
        this.wtx_attachments &&
        this.wtx_attachments.length &&
        this.wtx_attachments.length > 0
      ) {
        for (let i = 0; i < this.wtx_attachments.length; i++) {
          if (
            this.wtx_attachments &&
            this.wtx_attachments[i] &&
            this.wtx_attachments[i].file
          ) {
            formData.append(`file[${i}][file]`, this.wtx_attachments[i].file);
            formData.append(`file[${i}][name]`, this.wtx_attachments[i].name);
          }
        }
      }
      if (
        this.asset &&
        this.asset.skills_carts &&
        this.asset?.skills_carts?.length > 0
      ) {
        for (let i = 0; i < this.asset.skills_carts.length; i++) {
          formData.append(
            `skills_carts[${i}][id]`,
            this.asset.skills_carts[i].id
          );
          formData.append(
            `skills_carts[${i}][status]`,
            this.asset.skills_carts[i].status
          );
          formData.append(
            `skills_carts[${i}][color]`,
            this.asset.skills_carts[i].color
          );
          formData.append(
            `skills_carts[${i}][type]`,
            this.asset.skills_carts[i].type
          );
          formData.append(
            `skills_carts[${i}][name]`,
            this.asset.skills_carts[i].name
          );
        }
      }

      if (
        this.mtx_attachments &&
        this.mtx_attachments.length &&
        this.mtx_attachments.length > 0
      ) {
        for (let i = 0; i < this.mtx_attachments.length; i++) {
          if (
            this.mtx_attachments &&
            this.mtx_attachments[i] &&
            this.mtx_attachments[i].file
          ) {
            formData.append(
              `maintananace_file[${i}][file]`,
              this.mtx_attachments[i].file
            );
            formData.append(
              `maintananace_file[${i}][name]`,
              this.mtx_attachments[i].name
            );
          }
        }
      }

      //equipment files
      if (
        this.wtz_attachments &&
        this.wtz_attachments.length &&
        this.wtz_attachments.length > 0
      ) {
        for (let i = 0; i < this.wtz_attachments.length; i++) {
          if (
            this.wtz_attachments &&
            this.wtz_attachments[i] &&
            this.wtz_attachments[i].file
          ) {
            formData.append(
              `equipment_file[${i}][file]`,
              this.wtz_attachments[i].file
            );
            formData.append(
              `equipment_file[${i}][name]`,
              this.wtz_attachments[i].name
            );
          }
        }
      }

      if (this.asset && this.asset.salesperson) {
        formData.append(
          "salesperson",
          this.asset.salesperson ? this.asset.salesperson : null
        );
      }
      if (this.asset && this.asset.purchase_price) {
        formData.append(
          "purchase_price",
          this.asset.purchase_price ? this.asset.purchase_price : null
        );
      }
      if (this.asset && this.asset.purchase_date) {
        formData.append(
          "purchase_date",
          this.asset.purchase_date ? this.asset.purchase_date : null
        );
      }
      if (this.asset && this.asset.quotation_no) {
        formData.append(
          "quotation_no",
          this.asset.quotation_no ? this.asset.quotation_no : null
        );
      }
      if (this.asset && this.asset.invoice_no) {
        formData.append(
          "invoice_no",
          this.asset.invoice_no ? this.asset.invoice_no : null
        );
      }
      if (this.asset && this.asset.arrival_date) {
        formData.append(
          "arrival_date",
          this.asset.arrival_date ? this.asset.arrival_date : null
        );
      }
      if (this.asset && this.asset.prefix_no) {
        formData.append(
          "prefix_no",
          this.asset.prefix_no ? this.asset.prefix_no : null
        );
      }
      if (this.asset && this.asset.prefix) {
        formData.append("prefix", this.asset.prefix ? this.asset.prefix : null);
      }
      if (this.asset && this.asset.specification) {
        formData.append(
          "specification",
          this.asset.specification ? this.asset.specification : null
        );
      }
      if (this.asset && this.asset.machine_number) {
        formData.append(
          "machine_number",
          this.asset.machine_number ? this.asset.machine_number : null
        );
      }
      if (this.asset && this.asset.site_location) {
        formData.append(
          "site_location",
          this.asset.site_location ? this.asset.site_location : null
        );
      }

      // Add new fields for elevator specifications
      if (this.asset && this.asset.address) {
        formData.append("address", this.asset.address);
      }
      if (this.asset && this.asset.elevator_brand) {
        formData.append("elevator_brand", this.asset.elevator_brand);
      }
      if (this.asset && this.asset.lift_number) {
        formData.append("lift_number", this.asset.lift_number);
      }
      if (this.asset && this.asset.door_size) {
        formData.append("door_size", this.asset.door_size);
      }
      if (this.asset && this.asset.lift_type) {
        formData.append("lift_type", this.asset.lift_type);
      }
      if (this.asset && this.asset.interconnected_door_floor) {
        formData.append(
          "interconnected_door_floor",
          this.asset.interconnected_door_floor
        );
      }
      if (this.asset && this.asset.lift_brand) {
        formData.append("lift_brand", this.asset.lift_brand);
      }
      if (this.asset && this.asset.machine_room) {
        formData.append("machine_room", this.asset.machine_room);
      }
      if (this.asset && this.asset.control_system) {
        formData.append("control_system", this.asset.control_system);
      }
      if (this.asset && this.asset.rated_load) {
        formData.append("rated_load", this.asset.rated_load);
      }
      if (this.asset && this.asset.elevator_model) {
        formData.append("elevator_model", this.asset.elevator_model);
      }
      if (this.asset && this.asset.rated_speed) {
        formData.append("rated_speed", this.asset.rated_speed);
      }
      if (this.asset && this.asset.travel_distance) {
        formData.append("travel_distance", this.asset.travel_distance);
      }
      if (this.asset && this.asset.number_of_stops) {
        formData.append("number_of_stops", this.asset.number_of_stops);
      }
      if (this.asset && this.asset.top_clearance) {
        formData.append("top_clearance", this.asset.top_clearance);
      }
      if (this.asset && this.asset.bottom_clearance) {
        formData.append("bottom_clearance", this.asset.bottom_clearance);
      }
      if (this.asset && this.asset.encoder_model) {
        formData.append("encoder_model", this.asset.encoder_model);
      }
      if (this.asset && this.asset.traction_radio) {
        formData.append("traction_radio", this.asset.traction_radio);
      }
      if (this.asset && this.asset.number_of_rope) {
        formData.append("number_of_rope", this.asset.number_of_rope);
      }
      if (this.asset && this.asset.rope_diameter) {
        formData.append("rope_diameter", this.asset.rope_diameter);
      }
      if (this.asset && this.asset.main_sheave_diameter) {
        formData.append(
          "main_sheave_diameter",
          this.asset.main_sheave_diameter
        );
      }
      if (this.asset && this.asset.elevator_installation_date) {
        formData.append(
          "elevator_installation_date",
          this.asset.elevator_installation_date
        );
      }
      if (this.asset && this.asset.elevator_pto_date) {
        formData.append("elevator_pto_date", this.asset.elevator_pto_date);
      }
      if (this.asset && this.asset.drive_system) {
        formData.append("drive_system", this.asset.drive_system);
      }
      if (this.asset && this.asset.type_of_machine) {
        formData.append("type_of_machine", this.asset.type_of_machine);
      }
      if (this.asset && this.asset.tensioning_mechanism) {
        formData.append(
          "tensioning_mechanism",
          this.asset.tensioning_mechanism
        );
      }
      if (this.asset && this.asset.type_of_car_door) {
        formData.append("type_of_car_door", this.asset.type_of_car_door);
      }
      if (this.asset && this.asset.rated_power) {
        formData.append("rated_power", this.asset.rated_power);
      }
      if (this.asset && this.asset.rated_power_type) {
        formData.append("rated_power_type", this.asset.rated_power_type);
      }
      if (this.asset && this.asset.rated_voltage) {
        formData.append("rated_voltage", this.asset.rated_voltage);
      }
      if (this.asset && this.asset.rated_voltage_type) {
        formData.append("rated_voltage_type", this.asset.rated_voltage_type);
      }
      if (this.asset && this.asset.rated_current) {
        formData.append("rated_current", this.asset.rated_current);
      }
      if (this.asset && this.asset.rated_current_type) {
        formData.append("rated_current_type", this.asset.rated_current_type);
      }
      if (this.asset && this.asset.frequency) {
        formData.append("frequency", this.asset.frequency);
      }
      if (this.asset && this.asset.frequency_type) {
        formData.append("frequency_type", this.asset.frequency_type);
      }
      if (this.asset && this.asset.encode_shaft_diameter) {
        formData.append(
          "encode_shaft_diameter",
          this.asset.encode_shaft_diameter
        );
      }
      if (this.asset && this.asset.encode_shaft_diameter_type) {
        formData.append(
          "encode_shaft_diameter_type",
          this.asset.encode_shaft_diameter_type
        );
      }
      if (this.asset && this.asset.rated_rotational_speed) {
        formData.append(
          "rated_rotational_speed",
          this.asset.rated_rotational_speed
        );
      }
      if (this.asset && this.asset.rated_rotational_speed_type) {
        formData.append(
          "rated_rotational_speed_type",
          this.asset.rated_rotational_speed_type
        );
      }

      // Mapping NEW fields into formData
      if (this.asset && this.asset.speed_governor_brand) {
        formData.append(
          "speed_governor_brand",
          this.asset.speed_governor_brand
        );
      }
      if (this.asset && this.asset.speed_governor_rated_speed) {
        formData.append(
          "speed_governor_rated_speed",
          this.asset.speed_governor_rated_speed
        );
      }
      if (this.asset && this.asset.speed_governor_model) {
        formData.append(
          "speed_governor_model",
          this.asset.speed_governor_model
        );
      }
      if (this.asset && this.asset.speed_governor_rope_diameter) {
        formData.append(
          "speed_governor_rope_diameter",
          this.asset.speed_governor_rope_diameter
        );
      }
      if (this.asset && this.asset.speed_governor_installation_date) {
        formData.append(
          "speed_governor_installation_date",
          this.asset.speed_governor_installation_date
        );
      }
      if (this.asset && this.asset.speed_governor_tensioning_mechanism) {
        formData.append(
          "speed_governor_tensioning_mechanism",
          this.asset.speed_governor_tensioning_mechanism
        );
      }

      if (this.asset && this.asset.size_of_car) {
        formData.append("size_of_car", this.asset.size_of_car);
      }
      if (this.asset && this.asset.control_board) {
        formData.append("control_board", this.asset.control_board);
      }
      if (this.asset && this.asset.height_of_car) {
        formData.append("height_of_car", this.asset.height_of_car);
      }
      if (this.asset && this.asset.lighting_of_system) {
        formData.append("lighting_of_system", this.asset.lighting_of_system);
      }
      if (this.asset && this.asset.ventilation_system) {
        formData.append("ventilation_system", this.asset.ventilation_system);
      }
      if (this.asset && this.asset.car_door_width) {
        formData.append("car_door_width", this.asset.car_door_width);
      }
      if (this.asset && this.asset.car_door_height) {
        formData.append("car_door_height", this.asset.car_door_height);
      }
      if (this.asset && this.asset.car_safety_device) {
        formData.append("car_safety_device", this.asset.car_safety_device);
      }
      if (this.asset && this.asset.elevator_car_remark) {
        formData.append("elevator_car_remark", this.asset.elevator_car_remark);
      }
      if (this.asset && this.asset.car_internal_display_board) {
        formData.append(
          "car_internal_display_board",
          this.asset.car_internal_display_board
        );
      }
      if (this.asset && this.asset.car_model_of_button) {
        formData.append("car_model_of_button", this.asset.car_model_of_button);
      }
      if (this.asset && this.asset.car_external_display_board) {
        formData.append(
          "car_external_display_board",
          this.asset.car_external_display_board
        );
      }

      if (this.asset && this.asset.door_operator_model) {
        formData.append("door_operator_model", this.asset.door_operator_model);
      }
      if (this.asset && this.asset.door_operator_rated_power) {
        formData.append(
          "door_operator_rated_power",
          this.asset.door_operator_rated_power
        );
      }
      if (this.asset && this.asset.door_operator_rated_power_unit) {
        formData.append(
          "door_operator_rated_power_unit",
          this.asset.door_operator_rated_power_unit
        );
      }
      if (this.asset && this.asset.door_operator_rated_voltage) {
        formData.append(
          "door_operator_rated_voltage",
          this.asset.door_operator_rated_voltage
        );
      }
      if (this.asset && this.asset.door_operator_rated_voltage_unit) {
        formData.append(
          "door_operator_rated_voltage_unit",
          this.asset.door_operator_rated_voltage_unit
        );
      }
      if (this.asset && this.asset.door_operator_rated_current) {
        formData.append(
          "door_operator_rated_current",
          this.asset.door_operator_rated_current
        );
      }
      if (this.asset && this.asset.door_operator_rated_current_unit) {
        formData.append(
          "door_operator_rated_current_unit",
          this.asset.door_operator_rated_current_unit
        );
      }
      if (this.asset && this.asset.door_operator_rated_frequency) {
        formData.append(
          "door_operator_rated_frequency",
          this.asset.door_operator_rated_frequency
        );
      }
      if (this.asset && this.asset.door_operator_rated_frequency_unit) {
        formData.append(
          "door_operator_rated_frequency_unit",
          this.asset.door_operator_rated_frequency_unit
        );
      }
      if (this.asset && this.asset.door_operator_rope_belt) {
        formData.append(
          "door_operator_rope_belt",
          this.asset.door_operator_rope_belt
        );
      }
      if (this.asset && this.asset.door_wheel_model) {
        formData.append("door_wheel_model", this.asset.door_wheel_model);
      }
      if (this.asset && this.asset.door_wheel_model_2) {
        formData.append("door_wheel_model_2", this.asset.door_wheel_model_2);
      }
      if (this.asset && this.asset.model_of_door_strike) {
        formData.append(
          "model_of_door_strike",
          this.asset.model_of_door_strike
        );
      }
      if (this.asset && this.asset.door_lock_model) {
        formData.append("door_lock_model", this.asset.door_lock_model);
      }

      if (this.asset && this.asset.main_controller_board) {
        formData.append(
          "main_controller_board",
          this.asset.main_controller_board
        );
      }
      if (this.asset && this.asset.safety_circuit_board) {
        formData.append(
          "safety_circuit_board",
          this.asset.safety_circuit_board
        );
      }
      if (this.asset && this.asset.control_panel_inverter) {
        formData.append(
          "control_panel_inverter",
          this.asset.control_panel_inverter
        );
      }
      if (this.asset && this.asset.power_supply_board) {
        formData.append("power_supply_board", this.asset.power_supply_board);
      }
      if (this.asset && this.asset.door_controller_board) {
        formData.append(
          "door_controller_board",
          this.asset.door_controller_board
        );
      }
      if (this.asset && this.asset.expansion_board) {
        formData.append("expansion_board", this.asset.expansion_board);
      }
      if (this.asset && this.asset.comm_board) {
        formData.append("comm_board", this.asset.comm_board);
      }
      if (this.asset && this.asset.display_board) {
        formData.append("display_board", this.asset.display_board);
      }

      let requestTYPE = POST;
      let requestURL = "";
      if (this.equipmentId > 0) {
        requestURL = `equipment-new/${this.equipmentId}`;
      } else {
        requestURL = "equipment-new";
      }
      this.formLoading = true;
      this.$store
        .dispatch(requestTYPE, {
          url: requestURL,
          data: formData,
        })
        .then(({ data }) => {
          this.forcePush = true;
          if (this.isCustomer) {
            _this.$emit("update:warranty", true);
            _this.$emit("close:warranty", true);
          }
          if (!this.isCustomer) {
            this.goToDefaultDetail(data);
          }
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.formLoading = false;
        });
    },

    opendialogs(type) {
      switch (type) {
        case "driveSystemDialog":
          this.systemDialog = true;
          this.thelist = this.driveSystemList;
          this.placeholder = "Select Drive System";
          this.title = "Drive System";
          this.endpoint = "setting/motor-info/drive_system";
          this.value = "drive_system";
          break;

        case "openTypeOfMachineDialog":
          this.systemDialog = true;
          this.thelist = this.typeOfMachineList;
          this.placeholder = "Select Type of Machine";
          this.title = "Type of Machine";
          this.endpoint = "setting/motor-info/type_of_machine";
          this.value = "type_of_machine";
          break;
        case "tensioningMechanismDialog":
          this.systemDialog = true;
          this.thelist = this.tensioningMechanismList;
          this.placeholder = "Select Tensioning Mechanism";
          this.title = "Tensioning Mechanism";
          this.endpoint = "setting/motor-info/tensioning_mechanism";
          this.value = "tensioning_mechanism";
          break;
        case "openTypeOfCarDoorDialog":
          this.systemDialog = true;
          this.thelist = this.typeOfCarDoorList;
          this.placeholder = "Select Type of Car Door";
          this.title = "Type of Car Door";
          this.endpoint = "setting/motor-info/type_of_car_door";
          this.value = "type_of_car_door";
          break;

        case "openRatePowerTypeDialog":
          this.unitDialog = true;
          this.thelist = this.ratePowerType;
          this.placeholder = "Power Unit";
          this.title = "Power Rate Unit";
          this.product_type = "asset";
          this.type = "1";
          this.value = "rated_power_type";
          break;

        case "openRateVoltageTypeDialog":
          this.unitDialog = true;
          this.thelist = this.rateVoltageType;
          this.placeholder = "Voltage Unit";
          this.title = "Voltage Rate Unit";
          this.product_type = "asset";
          this.type = "1";
          this.value = "rated_voltage_type";
          break;

        case "openRateCurrentTypeDialog":
          this.unitDialog = true;
          this.thelist = this.rateCurrentType;
          this.placeholder = "Current Unit";
          this.title = "Rated Current Unit";
          this.product_type = "asset";
          this.type = "1";
          this.value = "rated_current_type";
          break;

        case "frequencyTypeDialog":
          this.unitDialog = true;
          this.thelist = this.frequencyType;
          this.placeholder = "Frequency Unit";
          this.title = "Frequency Unit";
          this.product_type = "asset";
          this.type = "1";
          this.value = "frequency_type";
          break;

        case "encodeShaftDiameterTypeDialog":
          this.unitDialog = true;
          this.thelist = this.encodeShaftDiameterType;
          this.placeholder = "Shaft Diameter Unit";
          this.title = "Shaft Diameter Unit";
          this.product_type = "asset";
          this.type = "1";
          this.value = "encode_shaft_diameter_type";
          break;

        case "ratedRotationalSpeedTypeDialog":
          this.unitDialog = true;
          this.thelist = this.ratedRotationalSpeedType;
          this.placeholder = "Rotational Speed Unit";
          this.title = "Rotational Speed Unit";
          this.product_type = "asset";
          this.type = "1";
          this.value = "rated_rotational_speed_type";
          break;

        case "ratePowerDoorTypeDialog":
          this.unitDialog = true;
          this.thelist = this.ratePowerDoorType;
          this.placeholder = "Power Rated Unit";
          this.title = "Power Rated Unit";
          this.product_type = "asset";
          this.type = "2";
          this.value = "door_operator_rated_power_unit";
          break;

        case "rateVoltageDoorTypeDialog":
          this.unitDialog = true;
          this.thelist = this.rateVoltageDoorType;
          this.placeholder = "Voltage Rated Unit";
          this.title = "Voltage Rated Unit";
          this.product_type = "asset";
          this.type = "2";
          this.value = "door_operator_rated_voltage_unit";
          break;

        case "rateCurrentDoorTypeDialog":
          this.unitDialog = true;
          this.thelist = this.rateCurrentDoorType;
          this.placeholder = "Current Rated Unit";
          this.title = "Current Rated Unit";
          this.product_type = "asset";
          this.type = "2";
          this.value = "door_operator_rated_current_unit";
          break;

        case "frequencyDoorTypeDialog":
          this.unitDialog = true;
          this.thelist = this.frequencyDoorType;
          this.placeholder = "Frequency Unit";
          this.title = "Frequency Unit";
          this.product_type = "asset";
          this.type = "2";
          this.value = "door_operator_rated_frequency_unit";
          break;
      }
    },
    closedialogs() {
      this.systemDialog = false;

      this.thelist = [];
      this.placeholder = "";
      this.title = "";
      this.endpoint = "";
      this.value = "";
    },

    closeUnitDialog() {
      this.unitDialog = false;

      this.thelist = [];
      this.placeholder = "";
      this.title = "";
      this.value = "";
      this.type = "";
      this.product_type = "";
    },
  },
  mounted() {
    this.get_options();
    this.$refs.assetForm.validate();
    if (this.equipmentId > 0) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: this.companyEquipmentType, route: "equipment" },
        { title: "Update" },
      ]);
    } else {
      this.changeWarrantyCheck(false);
      this.changeMaintananceCheck(false);
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: this.companyEquipmentType, route: "equipment" },
        { title: "Create" },
      ]);
    }
    if (this.asset?.installation_date && this.asset?.end_life) {
      this.getDates();
    }
  },
  created() {
    if (!this.isCreate) {
      this.equipmentId = this.lodash.toSafeInteger(this.$route.params.id);
    }
    this.companyEquipmentType = this.$route.query.equip_type
      ? this.$route.query.equip_type
      : "tool";
  },
  /*   beforeRouteLeave(to, from, next) {
      const _this = this;
      if (_this.isCustomerCreated) {
        next();
      } else {
        _this.routePreventDialog = true;
        PreventDialogEventBus.$on("stay-on-page", function () {
          _this.routePreventDialog = false;
          next(false);
        });
        PreventDialogEventBus.$on("leave-page", function () {
          _this.routePreventDialog = false;
          next();
        });
      }
    }, */
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.forcePush) {
      next();
    } else if (_this.isCustomerCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      /* if (this.contractId) {
          _this.routePreventDialog = false;
        } else {
          _this.routePreventDialog = true;
        } */
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
  computed: {
    getProfileImage() {
      return this.asset.asset_image ? this.asset.asset_image : null;
      /*  return this.lodash.isEmpty(this.asset.asset_image) === false 
          ? this.asset.asset_image.file.url
          : null; */
    },
  },
};
</script>
<style scoped>
/* tabs css  */

.custom-tab-transparent.v-tabs--fixed-tabs > .v-tabs-bar .v-tab.v-tab--active {
  background-color: #00bcd4 !important;
  color: #fff !important;
  overflow: hidden;
}

.custom-tab-transparent.v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tab.v-tab--active
  .grey--text.text--darken-4 {
  color: #fff !important;
  caret-color: #fff !important;
}

.custom-tab-transparent.v-tabs .v-tab {
  background: #00bcd429;
  width: 25%;
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}

.custom-tab-transparent.v-tabs .v-tab:first-child {
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 0px) 50%
  );
}

.custom-tab-transparent.v-tabs .v-tab.v-tab:last-child {
  clip-path: polygon(
    0% 0%,
    calc(100% + -0px) 0%,
    100% 100%,
    calc(100% - 40px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}

.mdi-close::before {
  margin-right: 25px;
  content: "\F0156";
}
</style>
